export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A type representing BigDecimal */
  BigDecimal: { input: any; output: any; }
  /** A type representing a formatted an instantaneous point on the timeline */
  Instant: { input: any; output: any; }
  /** A type representing local date */
  LocalDate: { input: any; output: any; }
  /** A type representing local time */
  LocalTime: { input: any; output: any; }
  /** A type representing long */
  Long: { input: any; output: any; }
  /** A type representing a string identifier */
  UUID: { input: any; output: any; }
  /** A type representing uploaded file */
  Upload: { input: any; output: any; }
};

export type ActionItemFilterInput = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
  done?: InputMaybe<Scalars['Boolean']['input']>;
  dueDateRange?: InputMaybe<DateRangeInput>;
};

export type ActionItemInput = {
  assigneeAgentId?: InputMaybe<Scalars['UUID']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  done: Scalars['Boolean']['input'];
  dueDate?: InputMaybe<Scalars['LocalDate']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  title: Scalars['String']['input'];
};

export type ActionItemOutput = {
  __typename?: 'ActionItemOutput';
  aiGenerated?: Maybe<Scalars['Boolean']['output']>;
  assigneeAgentId?: Maybe<Scalars['UUID']['output']>;
  assigneeAgentName?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['UUID']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Instant']['output'];
  done: Scalars['Boolean']['output'];
  dueDate?: Maybe<Scalars['LocalDate']['output']>;
  id: Scalars['UUID']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Instant']['output'];
};

export enum ActionItemSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum ActionItemSortField {
  CreatedAt = 'CREATED_AT',
  DueDate = 'DUE_DATE'
}

export type ActionItemSortInput = {
  direction: ActionItemSortDirection;
  field: ActionItemSortField;
};

export type Address = {
  __typename?: 'Address';
  aptNumber: Scalars['String']['output'];
  city: Scalars['String']['output'];
  county: Scalars['String']['output'];
  state: Scalars['String']['output'];
  streetName: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type AddressDto = {
  __typename?: 'AddressDto';
  aptNumber: Scalars['String']['output'];
  city: Scalars['String']['output'];
  state: Scalars['String']['output'];
  streetName: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type AddressDtoInput = {
  aptNumber: Scalars['String']['input'];
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  streetName: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type AdvisorDetailsInput = {
  phone: Scalars['String']['input'];
};

export type AdvisorDetailsOutput = {
  __typename?: 'AdvisorDetailsOutput';
  phone?: Maybe<Scalars['String']['output']>;
  userId: Scalars['UUID']['output'];
};

export type AffiliationPartnershipOutput = {
  __typename?: 'AffiliationPartnershipOutput';
  campaign: Scalars['String']['output'];
  source: Scalars['String']['output'];
  tag?: Maybe<Scalars['String']['output']>;
};

export type AgentAvailabilityOutput = {
  __typename?: 'AgentAvailabilityOutput';
  agentEmail: Scalars['String']['output'];
  availableSlotCount: Scalars['Int']['output'];
  busyPeriods: Array<BusyPeriod>;
  freeBlocks: Array<FreeBlock>;
  isWorkingDay: Scalars['Boolean']['output'];
  nextAvailableSlot?: Maybe<FreeBlock>;
  workingEnd?: Maybe<Scalars['Instant']['output']>;
  workingStart?: Maybe<Scalars['Instant']['output']>;
};

export type AgentAvailabilityStateCallDetails = {
  __typename?: 'AgentAvailabilityStateCallDetails';
  clientEmail: Scalars['String']['output'];
  clientId: Scalars['UUID']['output'];
  clientName: Scalars['String']['output'];
};

export type AgentAvailabilityStateOutput = {
  __typename?: 'AgentAvailabilityStateOutput';
  agentEmail: Scalars['String']['output'];
  agentId: Scalars['UUID']['output'];
  agentName: Scalars['String']['output'];
  airCallAvailabilityStatus?: Maybe<Scalars['String']['output']>;
  availabilityIsUpdatedAt?: Maybe<Scalars['Instant']['output']>;
  csr: Scalars['Boolean']['output'];
  dontDisturb: Scalars['Boolean']['output'];
  excludedFromRoundRobin: Scalars['Boolean']['output'];
  isAvailableForNewLeads: Scalars['Boolean']['output'];
  licensedStates?: Maybe<Scalars['String']['output']>;
  onCall: Scalars['Boolean']['output'];
  onCallWithClient?: Maybe<AgentAvailabilityStateCallDetails>;
  online: Scalars['Boolean']['output'];
  picUrl?: Maybe<Scalars['String']['output']>;
};

export type AgentCallAgendaOutput = {
  __typename?: 'AgentCallAgendaOutput';
  agentsOnline: Array<AgentsOnline>;
  assignedClientsCallTasks: Array<Scalars['UUID']['output']>;
  dontDisturb: Scalars['Boolean']['output'];
  scheduledReassignAt?: Maybe<Scalars['Instant']['output']>;
};

export enum AgentCallAgendaTaskAssignmentTypeOutput {
  Agent = 'AGENT',
  Csr = 'CSR'
}

export type AgentCallAgendaTaskCurrentAssignmentOutput = {
  __typename?: 'AgentCallAgendaTaskCurrentAssignmentOutput';
  assignedAgentEmail?: Maybe<Scalars['String']['output']>;
  assignedAgentId?: Maybe<Scalars['UUID']['output']>;
  assignedAgentName?: Maybe<Scalars['String']['output']>;
  assignedUntil?: Maybe<Scalars['Instant']['output']>;
  scheduledReassignAt?: Maybe<Scalars['Instant']['output']>;
  type: AgentCallAgendaTaskAssignmentTypeOutput;
};

export type AgentCallAgendaTaskHistoryItemOutput = {
  __typename?: 'AgentCallAgendaTaskHistoryItemOutput';
  agentEmail?: Maybe<Scalars['String']['output']>;
  agentId?: Maybe<Scalars['UUID']['output']>;
  agentName?: Maybe<Scalars['String']['output']>;
  type: AgentCallAgendaTaskAssignmentTypeOutput;
};

export type AgentCallAgendaTaskInPoolOutput = {
  __typename?: 'AgentCallAgendaTaskInPoolOutput';
  clientId: Scalars['UUID']['output'];
  inPoolUntil: Scalars['Instant']['output'];
};

export type AgentCallAgendaTaskOutput = {
  __typename?: 'AgentCallAgendaTaskOutput';
  assignmentHistory: Array<AgentCallAgendaTaskHistoryItemOutput>;
  clientEmail: Scalars['String']['output'];
  clientId: Scalars['UUID']['output'];
  clientName: Scalars['String']['output'];
  completed: Scalars['Boolean']['output'];
  createdAt: Scalars['Instant']['output'];
  currentAssignment?: Maybe<AgentCallAgendaTaskCurrentAssignmentOutput>;
  isNew: Scalars['Boolean']['output'];
  priority?: Maybe<Scalars['Int']['output']>;
  priorityReason?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type AgentCurrentClientsMetricsFilterInput = {
  agentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type AgentCurrentClientsMetricsOutput = {
  __typename?: 'AgentCurrentClientsMetricsOutput';
  agentEmail: Scalars['String']['output'];
  agentEnabled: Scalars['Boolean']['output'];
  agentId: Scalars['UUID']['output'];
  agentName: Scalars['String']['output'];
  followUpFuture: Scalars['Int']['output'];
  followUpNotFuture: Scalars['Int']['output'];
  followUpOutdated: Scalars['Int']['output'];
  sqlNotFuture: Scalars['Int']['output'];
  sqlOutdated: Scalars['Int']['output'];
  sqlUpFuture: Scalars['Int']['output'];
};

export type AgentEmailOutput = {
  __typename?: 'AgentEmailOutput';
  agentId: Scalars['UUID']['output'];
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Instant']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  snippet?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type AgentEmailPageOutput = {
  __typename?: 'AgentEmailPageOutput';
  data: Array<AgentEmailOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export enum AgentField {
  Email = 'EMAIL',
  Enabled = 'ENABLED',
  Name = 'NAME'
}

export type AgentFilterInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AgentInput = {
  b2bMeetingUrl?: InputMaybe<Scalars['String']['input']>;
  consultationUrl?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabledForRoundRobin?: InputMaybe<Scalars['Boolean']['input']>;
  enrollmentMeetingUrl?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isCSR?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  picUrl?: InputMaybe<Scalars['String']['input']>;
  planReviewUrl?: InputMaybe<Scalars['String']['input']>;
  receiveEmails?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<AgentRoleInput>;
};

export type AgentOutput = {
  __typename?: 'AgentOutput';
  b2bMeetingUrl?: Maybe<Scalars['String']['output']>;
  consultationUrl?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  enabledForRoundRobin?: Maybe<Scalars['Boolean']['output']>;
  enrollmentMeetingUrl?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isCSR: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  picUrl?: Maybe<Scalars['String']['output']>;
  planReviewUrl?: Maybe<Scalars['String']['output']>;
  receiveEmails: Scalars['Boolean']['output'];
  role: Scalars['String']['output'];
};

export type AgentPerformanceMetricOutput = {
  __typename?: 'AgentPerformanceMetricOutput';
  primaryKey: Scalars['String']['output'];
  secondaryKey?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['BigDecimal']['output']>;
};

export type AgentQaReportOutput = {
  __typename?: 'AgentQaReportOutput';
  agentId?: Maybe<Scalars['UUID']['output']>;
  agentName?: Maybe<Scalars['String']['output']>;
  mostFailedQuestions: Array<QaQuestionStatOutput>;
  pointsLostByCategory: Array<QaCategoryStatOutput>;
  recentCalls: Array<QaCallRowOutput>;
  summary: QaSummaryOutput;
};

export enum AgentRoleInput {
  RoleAdmin = 'ROLE_ADMIN',
  RoleAgentManager = 'ROLE_AGENT_MANAGER',
  RoleCsr = 'ROLE_CSR',
  RoleSuperAdmin = 'ROLE_SUPER_ADMIN',
  RoleTechStaff = 'ROLE_TECH_STAFF'
}

export enum AgentSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type AgentSortInput = {
  direction: AgentSortDirection;
  field: AgentField;
};

export type AgentViewOutput = {
  __typename?: 'AgentViewOutput';
  b2bMeetingUrl?: Maybe<Scalars['String']['output']>;
  consultationUrl?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  enrollmentMeetingUrl?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  picUrl?: Maybe<Scalars['String']['output']>;
  planReviewUrl?: Maybe<Scalars['String']['output']>;
};

export type AgentWorkingHoursOutput = {
  __typename?: 'AgentWorkingHoursOutput';
  agentEmail: Scalars['String']['output'];
  calendarEventId?: Maybe<Scalars['String']['output']>;
  dayOfWeek: DayOfWeek;
  endTime: Scalars['LocalTime']['output'];
  startTime: Scalars['LocalTime']['output'];
  timezone: Scalars['String']['output'];
};

export type AgentsOnline = {
  __typename?: 'AgentsOnline';
  agentId: Scalars['UUID']['output'];
  firstName: Scalars['String']['output'];
  isCsr: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
};

export type AllEnrollmentsFilterInput = {
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  createdByAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<EnrollmentType>;
};

export type AppointmentInviteeOutput = {
  __typename?: 'AppointmentInviteeOutput';
  clientId?: Maybe<Scalars['UUID']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type AppointmentOutput = {
  __typename?: 'AppointmentOutput';
  agent: AgentOutput;
  createdAt: Scalars['Instant']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['Instant']['output']>;
  invitee: AppointmentInviteeOutput;
  name: Scalars['String']['output'];
  noShow?: Maybe<Scalars['Boolean']['output']>;
  startTime?: Maybe<Scalars['Instant']['output']>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['Instant']['output'];
  url: Scalars['String']['output'];
};

export type AppointmentRequestOutput = {
  __typename?: 'AppointmentRequestOutput';
  clientId?: Maybe<Scalars['UUID']['output']>;
  createdAt: Scalars['Instant']['output'];
  createdCalendlyId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  requestedAppointmentAt?: Maybe<Scalars['String']['output']>;
};

export type AssignedTagViewOutput = {
  __typename?: 'AssignedTagViewOutput';
  aiGenerated?: Maybe<Scalars['Boolean']['output']>;
  expiresAt?: Maybe<Scalars['Instant']['output']>;
  tag: TagViewOutput;
};

export type AssignmentHistoryOutput = {
  __typename?: 'AssignmentHistoryOutput';
  agentName: Scalars['String']['output'];
  assignmentDate: Scalars['Instant']['output'];
  assignmentType: AssignmentHistoryType;
};

export enum AssignmentHistoryType {
  Assign = 'ASSIGN',
  ClearAssign = 'CLEAR_ASSIGN',
  Unwatch = 'UNWATCH',
  Watch = 'WATCH'
}

export type AttemptedLeadFilterInput = {
  badNumbersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  excludeBadNumbers?: InputMaybe<Scalars['Boolean']['input']>;
  excludeCalledToday?: InputMaybe<Scalars['Boolean']['input']>;
  excludeDoNotCall?: InputMaybe<Scalars['Boolean']['input']>;
  excludedTags?: InputMaybe<Array<Scalars['UUID']['input']>>;
  iep?: InputMaybe<Scalars['Boolean']['input']>;
  includedTags?: InputMaybe<Array<Scalars['UUID']['input']>>;
  leadGroup?: InputMaybe<AttemptedLeadGroupDto>;
  range?: InputMaybe<DateRangeInput>;
  state?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<ClientViewTimeZone>;
};

export enum AttemptedLeadGroupDto {
  CalledToday = 'CALLED_TODAY',
  Group_1 = 'GROUP_1',
  Group_2 = 'GROUP_2',
  Group_3 = 'GROUP_3',
  Group_4 = 'GROUP_4',
  Group_5 = 'GROUP_5',
  Group_6 = 'GROUP_6',
  Group_7 = 'GROUP_7'
}

export type AttemptedLeadOutput = {
  __typename?: 'AttemptedLeadOutput';
  birthDate?: Maybe<Scalars['Instant']['output']>;
  callsCount: Scalars['Int']['output'];
  clientId: Scalars['UUID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  iepFlag?: Maybe<Scalars['Boolean']['output']>;
  lastCallAgentFullName?: Maybe<Scalars['String']['output']>;
  lastCallDate?: Maybe<Scalars['Instant']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  leadDate: Scalars['Instant']['output'];
  leadGroup?: Maybe<AttemptedLeadGroupDto>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status: Status;
  tags: Array<AssignedTagViewOutput>;
  urgent: Scalars['Boolean']['output'];
};

export enum AttemptedLeadSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum AttemptedLeadSortField {
  Birthdate = 'BIRTHDATE',
  LeadDate = 'LEAD_DATE'
}

export type AttemptedLeadSortInput = {
  direction: AttemptedLeadSortDirection;
  field: AttemptedLeadSortField;
};

export type BusyPeriod = {
  __typename?: 'BusyPeriod';
  end: Scalars['Instant']['output'];
  start: Scalars['Instant']['output'];
};

export enum CalcDrugFrequencyPeriodInput {
  Daily = 'DAILY',
  HalfYearly = 'HALF_YEARLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export enum CalcDrugFrequencyPeriodViewOutput {
  Daily = 'DAILY',
  HalfYearly = 'HALF_YEARLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type CalendarEventAttendeeOutput = {
  __typename?: 'CalendarEventAttendeeOutput';
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  responseStatus?: Maybe<Scalars['String']['output']>;
  self?: Maybe<Scalars['Boolean']['output']>;
};

export enum CalendarEventChangeType {
  Created = 'CREATED',
  Deleted = 'DELETED',
  Updated = 'UPDATED'
}

export type CalendarEventOutput = {
  __typename?: 'CalendarEventOutput';
  attendeeEmails: Array<Scalars['String']['output']>;
  attendees?: Maybe<Array<CalendarEventAttendeeOutput>>;
  colorId?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['Instant']['output']>;
  creatorEmail?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dialInPhone?: Maybe<Scalars['String']['output']>;
  dialInPin?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  endDateTime?: Maybe<Scalars['Instant']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  htmlLink?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  meetLink?: Maybe<Scalars['String']['output']>;
  morePhoneNumbersUrl?: Maybe<Scalars['String']['output']>;
  organizer?: Maybe<Scalars['String']['output']>;
  organizerName?: Maybe<Scalars['String']['output']>;
  recurrence?: Maybe<Array<Scalars['String']['output']>>;
  reminderMinutes?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  startDateTime?: Maybe<Scalars['Instant']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['Instant']['output']>;
};

export enum CalendarEventResponse {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Tentative = 'TENTATIVE'
}

export type CalendarEventUpdateOutput = {
  __typename?: 'CalendarEventUpdateOutput';
  agentEmail: Scalars['String']['output'];
  changeType: CalendarEventChangeType;
  event?: Maybe<CalendarEventOutput>;
  eventId: Scalars['String']['output'];
};

export type CalendarEventsOutput = {
  __typename?: 'CalendarEventsOutput';
  events: Array<CalendarEventOutput>;
  nextPageToken?: Maybe<Scalars['String']['output']>;
};

export type CalendlyAppointmentsFilterInput = {
  startFrom?: InputMaybe<Scalars['Instant']['input']>;
  startTo?: InputMaybe<Scalars['Instant']['input']>;
};

export enum CalendlyAppointmentsSortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export enum CalendlyAppointmentsSortField {
  StartTime = 'startTime'
}

export type CalendlyAppointmentsSortInput = {
  direction: CalendlyAppointmentsSortDirection;
  field: CalendlyAppointmentsSortField;
};

export type CallHistoryAiAnalysisOutput = {
  __typename?: 'CallHistoryAIAnalysisOutput';
  aiAnalysis: Scalars['String']['output'];
  airCallTimeline?: Maybe<Scalars['String']['output']>;
  callHistoryId: Scalars['UUID']['output'];
};

export type CallHistoryAnalysisOutput = {
  __typename?: 'CallHistoryAnalysisOutput';
  sentiment?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  topics?: Maybe<Array<Scalars['String']['output']>>;
};

export enum CallHistoryCallType {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND'
}

export type CallHistoryInput = {
  callType?: InputMaybe<CallHistoryCallType>;
  clientId: Scalars['UUID']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  phoneNumber: Scalars['String']['input'];
  result?: InputMaybe<CallHistoryResultInput>;
};

export type CallHistoryOutput = {
  __typename?: 'CallHistoryOutput';
  agent?: Maybe<AgentViewOutput>;
  airCallId?: Maybe<Scalars['Long']['output']>;
  audioRecordId?: Maybe<Scalars['Long']['output']>;
  callHistoryAnalysis?: Maybe<CallHistoryAnalysisOutput>;
  callQa?: Maybe<CallQaOutput>;
  callType?: Maybe<CallHistoryCallType>;
  clientId: Scalars['UUID']['output'];
  createdAt?: Maybe<Scalars['Instant']['output']>;
  hasAIAnalysis: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['UUID']['output']>;
  maskedTranscript?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  result?: Maybe<Scalars['String']['output']>;
  transcription?: Maybe<Scalars['String']['output']>;
};

export enum CallHistoryResultInput {
  SuccessfulBookedCall = 'SUCCESSFUL_BOOKED_CALL',
  SuccessfulSeeNotesForCallDetails = 'SUCCESSFUL_SEE_NOTES_FOR_CALL_DETAILS',
  SuccessfulWarmTransfer = 'SUCCESSFUL_WARM_TRANSFER',
  UnsuccessfulInvalidNumber = 'UNSUCCESSFUL_INVALID_NUMBER',
  UnsuccessfulLeftEmail = 'UNSUCCESSFUL_LEFT_EMAIL',
  UnsuccessfulLeftText = 'UNSUCCESSFUL_LEFT_TEXT',
  UnsuccessfulLeftVm = 'UNSUCCESSFUL_LEFT_VM'
}

export type CallQaFilterInput = {
  agentIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  answer?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  isEnrollmentCall?: InputMaybe<Scalars['Boolean']['input']>;
  questionId?: InputMaybe<Scalars['String']['input']>;
  range?: InputMaybe<DateRangeInput>;
  scoreMax?: InputMaybe<Scalars['Int']['input']>;
  scoreMin?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatusDto>;
  tags?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type CallQaOutput = {
  __typename?: 'CallQaOutput';
  applicableMax?: Maybe<Scalars['Int']['output']>;
  coachingRecommendations?: Maybe<Scalars['String']['output']>;
  dispositionClass: Scalars['String']['output'];
  effectiveScore?: Maybe<Scalars['Int']['output']>;
  isEnrollmentCall: Scalars['Boolean']['output'];
  overallAssessment?: Maybe<Scalars['String']['output']>;
  overriddenScore?: Maybe<Scalars['Int']['output']>;
  pointsLost?: Maybe<Scalars['Int']['output']>;
  qaScore?: Maybe<Scalars['Int']['output']>;
  questions: Array<QaQuestionOutput>;
  reviewNote?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['Instant']['output']>;
  reviewedBy?: Maybe<Scalars['UUID']['output']>;
  rubricVersion?: Maybe<Scalars['String']['output']>;
  scoredAt?: Maybe<Scalars['Instant']['output']>;
  wasOverridden: Scalars['Boolean']['output'];
};

export type ClientAdminItemOutput = {
  __typename?: 'ClientAdminItemOutput';
  aiGenerated: Scalars['Boolean']['output'];
  clientId?: Maybe<Scalars['UUID']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  done: Scalars['Boolean']['output'];
  dueDate?: Maybe<Scalars['LocalDate']['output']>;
  group: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  priority?: Maybe<Scalars['String']['output']>;
  sla?: Maybe<Scalars['String']['output']>;
  sourceNote?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ClientDetailsSubscriptionInput = {
  clientId: Scalars['UUID']['input'];
};

export enum ClientDrugDeliveryType {
  Both = 'BOTH',
  Mail = 'MAIL',
  Pharmacy = 'PHARMACY'
}

export type ClientFileInput = {
  link: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type ClientFileOutput = {
  __typename?: 'ClientFileOutput';
  link: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ClientGroupItemOutput = {
  __typename?: 'ClientGroupItemOutput';
  clientId: Scalars['UUID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type ClientGroupOutput = {
  __typename?: 'ClientGroupOutput';
  clients: Array<ClientGroupItemOutput>;
  id: Scalars['UUID']['output'];
};

export type ClientNoteOutput = {
  __typename?: 'ClientNoteOutput';
  clientId: Scalars['UUID']['output'];
  createdAt: Scalars['Instant']['output'];
  createdByAgent?: Maybe<AgentViewOutput>;
  id: Scalars['UUID']['output'];
  isManagerNote: Scalars['Boolean']['output'];
  note: Scalars['String']['output'];
  updatedAt: Scalars['Instant']['output'];
};

export type ClientQaReportOutput = {
  __typename?: 'ClientQaReportOutput';
  aggregate: AgentQaReportOutput;
  calls: Array<QaCallRowOutput>;
};

export type ClientTagInput = {
  clientId: Scalars['UUID']['input'];
  tags: Array<TagAssignedToClientInput>;
};

export type ClientTrackingIdDtoInput = {
  trackingId: Scalars['String']['input'];
  type: TrackingIdTypeDto;
};

export type ClientViewFilterInput = {
  adviserEmail?: InputMaybe<Scalars['String']['input']>;
  agentId?: InputMaybe<Scalars['UUID']['input']>;
  aiGeneratedTags?: InputMaybe<Scalars['Boolean']['input']>;
  birthDate?: InputMaybe<DateRangeInput>;
  followUpDate?: InputMaybe<DateRangeInput>;
  justNerdWallet?: InputMaybe<Scalars['Boolean']['input']>;
  marketingCampaign?: InputMaybe<Scalars['String']['input']>;
  marketingSource?: InputMaybe<Scalars['String']['input']>;
  range?: InputMaybe<DateRangeInput>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<StatusDto>;
  tags?: InputMaybe<Array<Scalars['UUID']['input']>>;
  timeZone?: InputMaybe<ClientViewTimeZone>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
};

export type ClientViewForAdviserOutput = {
  __typename?: 'ClientViewForAdviserOutput';
  agentCalendlyUrl?: Maybe<Scalars['String']['output']>;
  appointmentAttended?: Maybe<Scalars['Boolean']['output']>;
  appointmentStartAt?: Maybe<Scalars['Instant']['output']>;
  assignedAgentEmail?: Maybe<Scalars['String']['output']>;
  assignedAgentName?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['LocalDate']['output']>;
  callScheduled?: Maybe<Scalars['Boolean']['output']>;
  clientId: Scalars['UUID']['output'];
  countyName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Instant']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enrollmentCarrier?: Maybe<Scalars['String']['output']>;
  enrollmentEffectiveDate?: Maybe<Scalars['LocalDate']['output']>;
  enrollmentPlanName?: Maybe<Scalars['String']['output']>;
  enrollmentType?: Maybe<Scalars['String']['output']>;
  enrollmentWritingAgentEmail?: Maybe<Scalars['String']['output']>;
  enrollments?: Maybe<Array<EnrollmentAdvisorViewOutput>>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  hasAppointment: Scalars['Boolean']['output'];
  hasEnrollment: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  medigapQuoteId?: Maybe<Scalars['UUID']['output']>;
  pdpQuoteId?: Maybe<Scalars['UUID']['output']>;
  quoteCreated?: Maybe<Scalars['Boolean']['output']>;
  quoteId?: Maybe<Scalars['UUID']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  tobacco?: Maybe<Scalars['Boolean']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type ClientViewListRepresentationOutput = {
  __typename?: 'ClientViewListRepresentationOutput';
  affiliationPartnershipSource?: Maybe<Scalars['String']['output']>;
  agentId?: Maybe<Scalars['UUID']['output']>;
  agentName?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['LocalDate']['output']>;
  callsCount: Scalars['String']['output'];
  clientId?: Maybe<Scalars['UUID']['output']>;
  createdAt?: Maybe<Scalars['Instant']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  expectedCloseDate?: Maybe<Scalars['LocalDate']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  followUpDate?: Maybe<Scalars['LocalDate']['output']>;
  lastCallDate?: Maybe<Scalars['Instant']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  latestNote?: Maybe<Scalars['String']['output']>;
  latestNoteId?: Maybe<Scalars['UUID']['output']>;
  managerNote?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumber2?: Maybe<Scalars['String']['output']>;
  profileSource?: Maybe<ProfileSource>;
  state?: Maybe<Scalars['String']['output']>;
  status: StatusDto;
  tags: Array<AssignedTagViewOutput>;
  urgentCallType?: Maybe<UrgentCallTypeDto>;
  userId?: Maybe<Scalars['UUID']['output']>;
};

export type ClientViewOutput = {
  __typename?: 'ClientViewOutput';
  additionalInformation?: Maybe<Scalars['String']['output']>;
  adviserEmail?: Maybe<Scalars['String']['output']>;
  adviserName?: Maybe<Scalars['String']['output']>;
  adviserPhone?: Maybe<Scalars['String']['output']>;
  affiliationPartnershipSource?: Maybe<Scalars['String']['output']>;
  agent?: Maybe<AgentViewOutput>;
  agentMedicareQuote?: Maybe<MedicareQuoteOutput>;
  agentMedigapQuote?: Maybe<MedigapQuoteViewOutput>;
  birthDate?: Maybe<Scalars['LocalDate']['output']>;
  bookingFor?: Maybe<Scalars['String']['output']>;
  cId?: Maybe<Scalars['String']['output']>;
  clientFiles: Array<ClientFileOutput>;
  countyName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  customAnswers?: Maybe<Scalars['String']['output']>;
  disqualifiedReason?: Maybe<DisqualifiedReasonDto>;
  doctors: Array<DoctorViewOutput>;
  drugDeliveryType?: Maybe<DrugDeliveryTypeViewOutput>;
  drugs: Array<DrugViewOutput>;
  eligibleName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enrolled?: Maybe<Scalars['String']['output']>;
  enrollment?: Maybe<EnrollmentViewOutput>;
  expectedCloseDate?: Maybe<Scalars['LocalDate']['output']>;
  fbclid?: Maybe<Scalars['String']['output']>;
  filters?: Maybe<FiltersOutput>;
  firstName?: Maybe<Scalars['String']['output']>;
  followUpDate?: Maybe<Scalars['LocalDate']['output']>;
  gbraid?: Maybe<Scalars['String']['output']>;
  gclid?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isDNC: Scalars['Boolean']['output'];
  isLitigator: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  leadSources?: Maybe<Array<LeadSourceOutput>>;
  managerNote?: Maybe<Scalars['String']['output']>;
  medicareNumber?: Maybe<Scalars['String']['output']>;
  medicarePartAStartedAt?: Maybe<Scalars['Instant']['output']>;
  medicarePartBStartedAt?: Maybe<Scalars['Instant']['output']>;
  medigapEnrollment?: Maybe<MedigapEnrollmentViewOutput>;
  medigapQuote?: Maybe<MedigapQuoteViewOutput>;
  msclkid?: Maybe<Scalars['String']['output']>;
  noShow?: Maybe<Scalars['Boolean']['output']>;
  notes: Array<ClientNoteOutput>;
  originalClientId?: Maybe<Scalars['UUID']['output']>;
  pdpEnrollment?: Maybe<PdpEnrollmentViewOutput>;
  pdpQuote?: Maybe<PdpQuoteOutput>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumber2?: Maybe<Scalars['String']['output']>;
  pin?: Maybe<Scalars['String']['output']>;
  planTypes?: Maybe<Array<Scalars['String']['output']>>;
  preCallBriefing?: Maybe<PreCallBriefingOutput>;
  preferredDrugs: Array<PreferredDrugViewOutput>;
  preferredPharmacies: Array<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['UUID']['output']>;
  profileSource?: Maybe<ProfileSource>;
  purchasedProducts: Array<PurchasedProductOutput>;
  quoteId?: Maybe<Scalars['UUID']['output']>;
  recordedLineAgreementCheck?: Maybe<Scalars['Boolean']['output']>;
  retireIn3Months?: Maybe<Scalars['String']['output']>;
  scheduledTagPlacement?: Maybe<Scalars['Boolean']['output']>;
  scopeOfAppointmentStatus?: Maybe<ScopeOfAppointmentStatusDto>;
  soaAgreement?: Maybe<Scalars['Boolean']['output']>;
  soaAgreementCheck?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status: StatusDto;
  tags: Array<AssignedTagViewOutput>;
  tobacco?: Maybe<Scalars['Boolean']['output']>;
  tpmoAgreementCheck?: Maybe<Scalars['Boolean']['output']>;
  uId?: Maybe<Scalars['String']['output']>;
  urgentCallRequested?: Maybe<Scalars['Boolean']['output']>;
  urgentCallType?: Maybe<UrgentCallTypeDto>;
  userId?: Maybe<Scalars['UUID']['output']>;
  utmBrand?: Maybe<Scalars['String']['output']>;
  utmCampaign?: Maybe<Scalars['String']['output']>;
  utmContent?: Maybe<Scalars['String']['output']>;
  utmMedium?: Maybe<Scalars['String']['output']>;
  utmSource?: Maybe<Scalars['String']['output']>;
  utmTerm?: Maybe<Scalars['String']['output']>;
  watchers: Array<AgentViewOutput>;
  wbraid?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type ClientViewSortInput = {
  direction: SortDirection;
  field: Field;
};

export enum ClientViewTimeZone {
  Akst = 'AKST',
  Cst = 'CST',
  Est = 'EST',
  Hst = 'HST',
  Mst = 'MST',
  Pst = 'PST'
}

export type ClientWatcherInput = {
  agentIds: Array<Scalars['UUID']['input']>;
  clientId: Scalars['UUID']['input'];
};

export type CompareOfferHistoryInput = {
  clientId: Scalars['UUID']['input'];
  screenshotLink: Scalars['String']['input'];
};

export type CompareOfferHistoryOutput = {
  __typename?: 'CompareOfferHistoryOutput';
  clientId: Scalars['UUID']['output'];
  createdAt?: Maybe<Scalars['Instant']['output']>;
  id: Scalars['UUID']['output'];
  screenshotLink: Scalars['String']['output'];
};

export enum CoverRightProductDto {
  Ma = 'MA',
  Mg = 'MG',
  Pdp = 'PDP'
}

export type CreateCalendarEventInput = {
  addMeetLink?: InputMaybe<Scalars['Boolean']['input']>;
  attendeeEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  colorId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDateTime: Scalars['Instant']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  recurrence?: InputMaybe<Array<Scalars['String']['input']>>;
  reminderMinutes?: InputMaybe<Scalars['Int']['input']>;
  sendNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  startDateTime: Scalars['Instant']['input'];
  summary: Scalars['String']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type CsrTrackingReportOutput = {
  __typename?: 'CsrTrackingReportOutput';
  agentId: Scalars['UUID']['output'];
  bookedCallsCount: Scalars['Int']['output'];
  email: Scalars['String']['output'];
  futureAppointmentsCount: Scalars['Int']['output'];
  nonWarmTransfersAttendedCount: Scalars['Int']['output'];
  nonWarmTransfersCount: Scalars['Int']['output'];
  nonWarmTransfersNotAttendedCount: Scalars['Int']['output'];
  undispositionedAppointmentsCount: Scalars['Int']['output'];
  warmTransfersCount: Scalars['Int']['output'];
};

export type CurrentAgentCallAgendaStateOutput = {
  __typename?: 'CurrentAgentCallAgendaStateOutput';
  agentsSorted: Array<AgentAvailabilityStateOutput>;
  rrView: RrViewOutput;
  tasks: Array<AgentCallAgendaTaskOutput>;
};

export type DashboardSectionOutput = {
  __typename?: 'DashboardSectionOutput';
  agentId: Scalars['UUID']['output'];
  clientAdmin?: Maybe<Array<ClientAdminItemOutput>>;
  overdue?: Maybe<Array<OverdueItemOutput>>;
  plan?: Maybe<PlanSectionOutput>;
  reconnect?: Maybe<Array<ReconnectItemOutput>>;
  type: DashboardSectionType;
  wrapUp?: Maybe<WrapUpSectionOutput>;
};

export enum DashboardSectionType {
  ClientAdmin = 'CLIENT_ADMIN',
  Overdue = 'OVERDUE',
  Plan = 'PLAN',
  Reconnect = 'RECONNECT',
  Schedule = 'SCHEDULE',
  WrapUp = 'WRAP_UP'
}

export type DateRangeInput = {
  from: Scalars['Instant']['input'];
  to: Scalars['Instant']['input'];
};

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export enum DisqualifiedReasonDto {
  NoLongerInterestedInSwitching = 'NO_LONGER_INTERESTED_IN_SWITCHING',
  UnableToConnect = 'UNABLE_TO_CONNECT',
  WentToAnotherBroker = 'WENT_TO_ANOTHER_BROKER'
}

export type DoctorAddressViewOutput = {
  __typename?: 'DoctorAddressViewOutput';
  addressLine1: Scalars['String']['output'];
  addressLine2: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isPcp: Scalars['Boolean']['output'];
  specialty: Scalars['String']['output'];
};

export type DoctorViewOutput = {
  __typename?: 'DoctorViewOutput';
  addresses: Array<DoctorAddressViewOutput>;
  addressesNumber: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  npi: Scalars['String']['output'];
  pcpDetails: Array<PcpInfoViewOutput>;
};

export enum DrugDeliveryTypeViewOutput {
  Both = 'BOTH',
  Mail = 'MAIL',
  Pharmacy = 'PHARMACY'
}

export type DrugViewOutput = {
  __typename?: 'DrugViewOutput';
  frequency?: Maybe<Scalars['String']['output']>;
  genericName?: Maybe<Scalars['String']['output']>;
  genericRxcui?: Maybe<Scalars['String']['output']>;
  isGeneric?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  packName?: Maybe<Scalars['String']['output']>;
  packRxcui?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['BigDecimal']['output']>;
  rxcui?: Maybe<Scalars['String']['output']>;
};

export enum EmailMeMaPagePlanYear {
  Year2021 = 'YEAR2021',
  Year2022 = 'YEAR2022',
  Year2023 = 'YEAR2023'
}

export type EmailTemplateDto = {
  __typename?: 'EmailTemplateDto';
  id?: Maybe<Scalars['UUID']['output']>;
  template: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type EmailTemplateDtoInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  template: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type EnrollmentAddressOutput = {
  __typename?: 'EnrollmentAddressOutput';
  aptNumber: Scalars['String']['output'];
  city: Scalars['String']['output'];
  state: Scalars['String']['output'];
  streetName: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type EnrollmentAdvisorViewOutput = {
  __typename?: 'EnrollmentAdvisorViewOutput';
  agentEmail?: Maybe<Scalars['String']['output']>;
  agentName?: Maybe<Scalars['String']['output']>;
  carrierName?: Maybe<Scalars['String']['output']>;
  clientId: Scalars['UUID']['output'];
  effectiveDate?: Maybe<Scalars['LocalDate']['output']>;
  enrollmentType?: Maybe<Scalars['String']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
};

export type EnrollmentFilterInput = {
  isImported?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<EnrollmentStatusInput>>;
};

export type EnrollmentInput = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
  applicationDate?: InputMaybe<Scalars['LocalDate']['input']>;
  bidId?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['LocalDate']['input']>;
  carrierName?: InputMaybe<Scalars['String']['input']>;
  communicationPreference?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['LocalDate']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enrollmentType?: InputMaybe<MedicareEnrollmentType>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isElectronicallyCommunications?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailingAddress?: InputMaybe<AddressDtoInput>;
  medicareNumber?: InputMaybe<Scalars['String']['input']>;
  medicarePartAStartedAt?: InputMaybe<Scalars['String']['input']>;
  medicarePartBStartedAt?: InputMaybe<Scalars['String']['input']>;
  permanentAddress?: InputMaybe<AddressDtoInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  planName?: InputMaybe<Scalars['String']['input']>;
  planYear?: InputMaybe<PlanYear>;
  preferredLanguage?: InputMaybe<PreferredLanguageDto>;
  quoteId?: InputMaybe<Scalars['UUID']['input']>;
  started?: InputMaybe<Scalars['Instant']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type EnrollmentListItemOutput = {
  __typename?: 'EnrollmentListItemOutput';
  age?: Maybe<Scalars['Int']['output']>;
  agentId?: Maybe<Scalars['UUID']['output']>;
  applicationDate?: Maybe<Scalars['LocalDate']['output']>;
  approvedAt?: Maybe<Scalars['Instant']['output']>;
  bidId?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['LocalDate']['output']>;
  carrierName?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['UUID']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Instant']['output']>;
  effectiveDate?: Maybe<Scalars['LocalDate']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enrollmentType?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  id: Scalars['UUID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  mgPlanKey?: Maybe<Scalars['String']['output']>;
  mgPlanName?: Maybe<Scalars['String']['output']>;
  naic?: Maybe<Scalars['String']['output']>;
  pdpQuoteId?: Maybe<Scalars['UUID']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  planYear?: Maybe<Scalars['String']['output']>;
  started?: Maybe<Scalars['Instant']['output']>;
  status: Scalars['String']['output'];
  tobacco?: Maybe<Scalars['Boolean']['output']>;
  type: EnrollmentType;
  zip?: Maybe<Scalars['String']['output']>;
};

export type EnrollmentOutput = {
  __typename?: 'EnrollmentOutput';
  agentId?: Maybe<Scalars['UUID']['output']>;
  applicationDate?: Maybe<Scalars['LocalDate']['output']>;
  approvedAt?: Maybe<Scalars['String']['output']>;
  bidId?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['LocalDate']['output']>;
  carrierName?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['UUID']['output']>;
  communicationPreference?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByAdmin: Scalars['Boolean']['output'];
  effectiveDate?: Maybe<Scalars['LocalDate']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enrollmentType?: Maybe<MedicareEnrollmentType>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isElectronicallyCommunications?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mailingAddress?: Maybe<AddressDto>;
  medicareNumber?: Maybe<Scalars['String']['output']>;
  medicarePartAStartedAt?: Maybe<Scalars['String']['output']>;
  medicarePartBStartedAt?: Maybe<Scalars['String']['output']>;
  permanentAddress?: Maybe<AddressDto>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  planYear?: Maybe<PlanYear>;
  preferredLanguage?: Maybe<PreferredLanguageDto>;
  quoteId?: Maybe<Scalars['UUID']['output']>;
  started?: Maybe<Scalars['Instant']['output']>;
  status: StatusOutput;
  userId?: Maybe<Scalars['UUID']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type EnrollmentPlanNameMigrationResult = {
  __typename?: 'EnrollmentPlanNameMigrationResult';
  maErrorCount: Scalars['Int']['output'];
  maSuccessfulCount: Scalars['Int']['output'];
  maTotalCount: Scalars['Int']['output'];
  medigapErrorCount: Scalars['Int']['output'];
  medigapSuccessfulCount: Scalars['Int']['output'];
  medigapTotalCount: Scalars['Int']['output'];
  pdpErrorCount: Scalars['Int']['output'];
  pdpSuccessfulCount: Scalars['Int']['output'];
  pdpTotalCount: Scalars['Int']['output'];
};

export enum EnrollmentPreferredLanguageDto {
  Chinese = 'CHINESE',
  English = 'ENGLISH',
  French = 'FRENCH',
  FrenchCreole = 'FRENCH_CREOLE',
  Korean = 'KOREAN',
  Polish = 'POLISH',
  Spanish = 'SPANISH',
  Vietnamese = 'VIETNAMESE'
}

export enum EnrollmentStatusDto {
  Draft = 'DRAFT',
  Enrolled = 'ENROLLED',
  New = 'NEW',
  Rejected = 'REJECTED',
  Sent = 'SENT'
}

export enum EnrollmentStatusInput {
  Draft = 'DRAFT',
  Enrolled = 'ENROLLED',
  New = 'NEW',
  Rejected = 'REJECTED',
  Sent = 'SENT'
}

export enum EnrollmentType {
  Ma = 'MA',
  Mg = 'MG',
  Pdp = 'PDP'
}

export type EnrollmentViewOutput = {
  __typename?: 'EnrollmentViewOutput';
  approvedAt?: Maybe<Scalars['String']['output']>;
  bidId?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['LocalDate']['output']>;
  communicationPreference?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isElectronicallyCommunications?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mailingAddress?: Maybe<EnrollmentAddressOutput>;
  medicareNumber?: Maybe<Scalars['String']['output']>;
  medicarePartAStartedAt: Scalars['String']['output'];
  medicarePartBStartedAt?: Maybe<Scalars['String']['output']>;
  permanentAddress?: Maybe<EnrollmentAddressOutput>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  preferredLanguage?: Maybe<EnrollmentPreferredLanguageDto>;
  quoteId?: Maybe<Scalars['UUID']['output']>;
  status: EnrollmentStatusDto;
  userId?: Maybe<Scalars['UUID']['output']>;
};

export enum EventName {
  FollowUp = 'FOLLOW_UP',
  Lead = 'LEAD',
  Sql = 'SQL'
}

export enum ExtraBenefit {
  Dental = 'DENTAL',
  DrugCoverage = 'DRUG_COVERAGE',
  Fitness = 'FITNESS',
  Hearing = 'HEARING',
  InsulinSavings = 'INSULIN_SAVINGS',
  OverTheCounter = 'OVER_THE_COUNTER',
  PartBPremiumGiveback = 'PART_B_PREMIUM_GIVEBACK',
  Telehealth = 'TELEHEALTH',
  Transportation = 'TRANSPORTATION',
  Vision = 'VISION',
  WorldwideEmergency = 'WORLDWIDE_EMERGENCY'
}

export enum Field {
  BirthDate = 'birthDate',
  CreatedAt = 'createdAt',
  Email = 'email',
  ExpectedCloseDate = 'expectedCloseDate',
  FirstName = 'firstName',
  FollowUpDate = 'followUpDate',
  Gender = 'gender',
  LastCallDate = 'lastCallDate',
  LastName = 'lastName',
  Note = 'note',
  PhoneNumber = 'phoneNumber',
  ScopeOfAppointmentStatus = 'scopeOfAppointmentStatus',
  Status = 'status',
  Zip = 'zip'
}

export type FiltersOutput = {
  __typename?: 'FiltersOutput';
  SNPTypes?: Maybe<Array<SnpType>>;
  companies?: Maybe<Array<Scalars['String']['output']>>;
  extraBenefits: Array<ExtraBenefit>;
  maxCostRangeNames?: Maybe<Array<Scalars['String']['output']>>;
  maxOutOfPocketRangeNames?: Maybe<Array<Scalars['String']['output']>>;
  partBPremiumReduction?: Maybe<Scalars['Boolean']['output']>;
  partDDrugCoverage?: Maybe<Scalars['Boolean']['output']>;
  planTypes?: Maybe<Array<Scalars['String']['output']>>;
  rating?: Maybe<Array<Rating>>;
};

export enum FormName {
  BasicInfo = 'BASIC_INFO',
  Calendar = 'CALENDAR',
  ChronicIllness = 'CHRONIC_ILLNESS',
  Doctors = 'DOCTORS',
  Drugs = 'DRUGS',
  Enrolled = 'ENROLLED',
  GovernmentAssistant = 'GOVERNMENT_ASSISTANT',
  HomeAddress = 'HOME_ADDRESS',
  Medicaid = 'MEDICAID',
  MedicareOverview = 'MEDICARE_OVERVIEW',
  PersonalDetails = 'PERSONAL_DETAILS',
  Pharmacies = 'PHARMACIES',
  PhoneNumber = 'PHONE_NUMBER',
  ReceivingBenefits = 'RECEIVING_BENEFITS',
  SearchResults = 'SEARCH_RESULTS',
  WorkInfo = 'WORK_INFO'
}

export type FreeBlock = {
  __typename?: 'FreeBlock';
  durationMinutes: Scalars['Long']['output'];
  end: Scalars['Instant']['output'];
  start: Scalars['Instant']['output'];
};

export type FreeBusyOutput = {
  __typename?: 'FreeBusyOutput';
  agentEmail: Scalars['String']['output'];
  busyPeriods: Array<BusyPeriod>;
};

export enum FrequencyPeriodInput {
  HalfYearly = 'HALF_YEARLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Yearly = 'YEARLY'
}

export enum FrequencyPeriodViewOutput {
  HalfYearly = 'HALF_YEARLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Yearly = 'YEARLY'
}

export enum Gender {
  F = 'F',
  M = 'M'
}

export type InviteePersonalInfoOutput = {
  __typename?: 'InviteePersonalInfoOutput';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type KeycloakUserInput = {
  email: Scalars['String']['input'];
  enrollmentId?: InputMaybe<Scalars['UUID']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['UUID']['input']>;
  quoteId?: InputMaybe<Scalars['UUID']['input']>;
};

export type KeycloakUserOutput = {
  __typename?: 'KeycloakUserOutput';
  enrollmentId: Scalars['UUID']['output'];
  userId: Scalars['UUID']['output'];
};

export type LeadSourceOutput = {
  __typename?: 'LeadSourceOutput';
  campaign: Scalars['String']['output'];
  content?: Maybe<Scalars['String']['output']>;
  eventDate: Scalars['LocalDate']['output'];
  medium: Scalars['String']['output'];
  source: Scalars['String']['output'];
  term?: Maybe<Scalars['String']['output']>;
};

export type ListCalendarEventsInput = {
  maxResults: Scalars['Int']['input'];
  pageToken?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  timeMax?: InputMaybe<Scalars['Instant']['input']>;
  timeMin?: InputMaybe<Scalars['Instant']['input']>;
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  accessToken: Scalars['String']['output'];
  idToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export enum MedicareEnrollmentType {
  MaNew = 'MA_NEW',
  MaReplacement = 'MA_REPLACEMENT',
  MaUnlikeChange = 'MA_UNLIKE_CHANGE'
}

export type MedicareQuoteOutput = {
  __typename?: 'MedicareQuoteOutput';
  agentOffer?: Maybe<Scalars['Boolean']['output']>;
  cId?: Maybe<Scalars['String']['output']>;
  countyName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Instant']['output']>;
  customAnswers?: Maybe<Scalars['String']['output']>;
  doctors: Array<DoctorViewOutput>;
  drugs: Array<DrugViewOutput>;
  filters?: Maybe<FiltersOutput>;
  pin?: Maybe<Scalars['String']['output']>;
  quoteId: Scalars['UUID']['output'];
  state?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['UUID']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export enum MedigapEnrollmentAccessibleFormat {
  AccessibleScreenReader = 'ACCESSIBLE_SCREEN_READER',
  Audio = 'AUDIO',
  Braille = 'BRAILLE',
  LargePrint = 'LARGE_PRINT',
  OralOverThePhone = 'ORAL_OVER_THE_PHONE'
}

export type MedigapEnrollmentAddress = {
  __typename?: 'MedigapEnrollmentAddress';
  aptNumber: Scalars['String']['output'];
  city: Scalars['String']['output'];
  county: Scalars['String']['output'];
  state: Scalars['String']['output'];
  streetName: Scalars['String']['output'];
  toRegular: Address;
  zip: Scalars['String']['output'];
};

export type MedigapEnrollmentAddressInput = {
  aptNumber: Scalars['String']['input'];
  city: Scalars['String']['input'];
  county: Scalars['String']['input'];
  state: Scalars['String']['input'];
  streetName: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type MedigapEnrollmentInput = {
  accessibleFormatPreference?: InputMaybe<MedigapEnrollmentAccessibleFormat>;
  age: Scalars['Int']['input'];
  agentId?: InputMaybe<Scalars['UUID']['input']>;
  applicationDate?: InputMaybe<Scalars['LocalDate']['input']>;
  birthDate?: InputMaybe<Scalars['LocalDate']['input']>;
  cId?: InputMaybe<Scalars['String']['input']>;
  carrierName?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  effectiveDate: Scalars['LocalDate']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  enrollmentType?: InputMaybe<MedigapEnrollmentType>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender: Gender;
  hospitalDate?: InputMaybe<Scalars['LocalDate']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailingAddress?: InputMaybe<MedigapEnrollmentAddressInput>;
  medicalDate?: InputMaybe<Scalars['LocalDate']['input']>;
  medicareNumber?: InputMaybe<Scalars['String']['input']>;
  medigapQuoteId?: InputMaybe<Scalars['UUID']['input']>;
  naic: Scalars['String']['input'];
  pdpBidId?: InputMaybe<Scalars['String']['input']>;
  permanentAddress?: InputMaybe<MedigapEnrollmentAddressInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  planKey: Scalars['String']['input'];
  planName: MedigapEnrollmentPlanName;
  planYear?: InputMaybe<PlanYear>;
  preferredLanguage?: InputMaybe<MedigapEnrollmentPreferredLanguage>;
  started?: InputMaybe<Scalars['Instant']['input']>;
  tobacco: Scalars['Boolean']['input'];
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type MedigapEnrollmentOutput = {
  __typename?: 'MedigapEnrollmentOutput';
  accessibleFormatPreference?: Maybe<MedigapEnrollmentAccessibleFormat>;
  age: Scalars['Int']['output'];
  agentId?: Maybe<Scalars['UUID']['output']>;
  applicationDate?: Maybe<Scalars['LocalDate']['output']>;
  approvedAt?: Maybe<Scalars['Instant']['output']>;
  birthDate?: Maybe<Scalars['LocalDate']['output']>;
  carrierName?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['UUID']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Instant']['output']>;
  effectiveDate: Scalars['LocalDate']['output'];
  email?: Maybe<Scalars['String']['output']>;
  enrollmentType?: Maybe<MedigapEnrollmentType>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender: Gender;
  hospitalDate?: Maybe<Scalars['LocalDate']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mailingAddress?: Maybe<MedigapEnrollmentAddress>;
  medicalDate?: Maybe<Scalars['LocalDate']['output']>;
  medicareNumber?: Maybe<Scalars['String']['output']>;
  medigapQuoteId?: Maybe<Scalars['UUID']['output']>;
  naic: Scalars['String']['output'];
  permanentAddress?: Maybe<MedigapEnrollmentAddress>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  planKey?: Maybe<Scalars['String']['output']>;
  planName: MedigapEnrollmentPlanName;
  planYear?: Maybe<PlanYear>;
  preferredLanguage?: Maybe<MedigapEnrollmentPreferredLanguage>;
  started?: Maybe<Scalars['Instant']['output']>;
  status: MedigapEnrollmentStatus;
  tobacco: Scalars['Boolean']['output'];
  zip?: Maybe<Scalars['String']['output']>;
};

export enum MedigapEnrollmentPlanName {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G',
  H = 'H',
  Hdf = 'HDF',
  Hdg = 'HDG',
  I = 'I',
  K = 'K',
  L = 'L',
  M = 'M',
  MaCore = 'MA_CORE',
  MaSupp1 = 'MA_SUPP1',
  MaSupp1A = 'MA_SUPP1A',
  MnrExcs = 'MNR_EXCS',
  MnrPrev = 'MNR_PREV',
  MnrPta = 'MNR_PTA',
  MnrPtb = 'MNR_PTB',
  MnrUhc1 = 'MNR_UHC1',
  MnrUprv = 'MNR_UPRV',
  MnBasic = 'MN_BASIC',
  MnExtb = 'MN_EXTB',
  MnHded = 'MN_HDED',
  MnPbco = 'MN_PBCO',
  MnXbas = 'MN_XBAS',
  MnXbas2 = 'MN_XBAS2',
  N = 'N',
  WiBase = 'WI_BASE'
}

export enum MedigapEnrollmentPreferredLanguage {
  Chinese = 'CHINESE',
  English = 'ENGLISH',
  French = 'FRENCH',
  FrenchCreole = 'FRENCH_CREOLE',
  Korean = 'KOREAN',
  Polish = 'POLISH',
  Spanish = 'SPANISH',
  Vietnamese = 'VIETNAMESE'
}

export enum MedigapEnrollmentStatus {
  Draft = 'DRAFT',
  Enrolled = 'ENROLLED',
  New = 'NEW',
  Rejected = 'REJECTED',
  Sent = 'SENT'
}

export enum MedigapEnrollmentType {
  MgGi = 'MG_GI',
  MgOep = 'MG_OEP',
  MgUnderwritten = 'MG_UNDERWRITTEN'
}

export enum MedigapEnrollmentViewAccessibleFormat {
  AccessibleScreenReader = 'ACCESSIBLE_SCREEN_READER',
  Audio = 'AUDIO',
  Braille = 'BRAILLE',
  LargePrint = 'LARGE_PRINT',
  OralOverThePhone = 'ORAL_OVER_THE_PHONE'
}

export type MedigapEnrollmentViewAddress = {
  __typename?: 'MedigapEnrollmentViewAddress';
  aptNumber: Scalars['String']['output'];
  city: Scalars['String']['output'];
  county: Scalars['String']['output'];
  state: Scalars['String']['output'];
  streetName: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export enum MedigapEnrollmentViewGender {
  F = 'F',
  M = 'M'
}

export type MedigapEnrollmentViewOutput = {
  __typename?: 'MedigapEnrollmentViewOutput';
  accessibleFormatPreference?: Maybe<MedigapEnrollmentViewAccessibleFormat>;
  age: Scalars['Int']['output'];
  approvedAt?: Maybe<Scalars['Instant']['output']>;
  birthDate?: Maybe<Scalars['LocalDate']['output']>;
  createdAt?: Maybe<Scalars['Instant']['output']>;
  effectiveDate: Scalars['LocalDate']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender: MedigapEnrollmentViewGender;
  hospitalDate?: Maybe<Scalars['LocalDate']['output']>;
  id: Scalars['UUID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  mailingAddress?: Maybe<MedigapEnrollmentViewAddress>;
  medicalDate?: Maybe<Scalars['LocalDate']['output']>;
  medicareNumber?: Maybe<Scalars['String']['output']>;
  naic: Scalars['String']['output'];
  pdpBidId?: Maybe<Scalars['String']['output']>;
  permanentAddress?: Maybe<MedigapEnrollmentViewAddress>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  planName: Scalars['String']['output'];
  preferredLanguage?: Maybe<MedigapEnrollmentViewPreferredLanguage>;
  quoteId?: Maybe<Scalars['UUID']['output']>;
  status: MedigapEnrollmentViewStatus;
  tobacco: Scalars['Boolean']['output'];
  userId?: Maybe<Scalars['UUID']['output']>;
};

export enum MedigapEnrollmentViewPreferredLanguage {
  Chinese = 'CHINESE',
  English = 'ENGLISH',
  French = 'FRENCH',
  FrenchCreole = 'FRENCH_CREOLE',
  Korean = 'KOREAN',
  Polish = 'POLISH',
  Spanish = 'SPANISH',
  Vietnamese = 'VIETNAMESE'
}

export enum MedigapEnrollmentViewStatus {
  Draft = 'DRAFT',
  Enrolled = 'ENROLLED',
  New = 'NEW',
  Rejected = 'REJECTED',
  Sent = 'SENT'
}

export type MedigapFilterInput = {
  isImported?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum MedigapFilterStateBenefit {
  ForeignTravelEmergency = 'FOREIGN_TRAVEL_EMERGENCY',
  PartADeductible = 'PART_A_DEDUCTIBLE',
  PartBDeductible = 'PART_B_DEDUCTIBLE',
  PartBExcessCharges = 'PART_B_EXCESS_CHARGES',
  SkilledNursingFacilities = 'SKILLED_NURSING_FACILITIES'
}

export enum MedigapFilterStateGender {
  F = 'F',
  M = 'M'
}

export enum MedigapFilterStatePlanName {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G',
  H = 'H',
  Hdf = 'HDF',
  Hdg = 'HDG',
  I = 'I',
  K = 'K',
  L = 'L',
  M = 'M',
  MaCore = 'MA_CORE',
  MaSupp1 = 'MA_SUPP1',
  MaSupp1A = 'MA_SUPP1A',
  MnrExcs = 'MNR_EXCS',
  MnrPrev = 'MNR_PREV',
  MnrPta = 'MNR_PTA',
  MnrPtb = 'MNR_PTB',
  MnrUhc1 = 'MNR_UHC1',
  MnrUprv = 'MNR_UPRV',
  MnBasic = 'MN_BASIC',
  MnExtb = 'MN_EXTB',
  MnHded = 'MN_HDED',
  MnPbco = 'MN_PBCO',
  MnXbas = 'MN_XBAS',
  N = 'N'
}

export type MedigapFilterStateViewOutput = {
  __typename?: 'MedigapFilterStateViewOutput';
  age: Scalars['Int']['output'];
  benefits?: Maybe<Array<MedigapFilterStateBenefit>>;
  companies?: Maybe<Array<Scalars['String']['output']>>;
  county?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['LocalDate']['output']>;
  gender: MedigapFilterStateGender;
  id?: Maybe<Scalars['UUID']['output']>;
  monthlyPlanPremiumRanges?: Maybe<Array<Scalars['String']['output']>>;
  planCategory?: Maybe<Scalars['String']['output']>;
  planNames?: Maybe<Array<MedigapFilterStatePlanName>>;
  tobacco: Scalars['Boolean']['output'];
  zip: Scalars['String']['output'];
};

export type MedigapQuoteViewOutput = {
  __typename?: 'MedigapQuoteViewOutput';
  cId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Instant']['output']>;
  id: Scalars['UUID']['output'];
  medigapFilterState?: Maybe<MedigapFilterStateViewOutput>;
  updatedAt?: Maybe<Scalars['Instant']['output']>;
  userId?: Maybe<Scalars['UUID']['output']>;
};

export type MigrateAgentRawDigitsState = {
  __typename?: 'MigrateAgentRawDigitsState';
  error?: Maybe<Scalars['String']['output']>;
  irProcessRunning: Scalars['Boolean']['output'];
  processedCount: Scalars['Int']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addClientFiles: Scalars['Boolean']['output'];
  appointmentReminderAgentConfirmedButWillBeLateConfirmByCsr: Scalars['Boolean']['output'];
  appointmentReminderAgentIsMissingAppointmentConfirmByCsr: Scalars['Boolean']['output'];
  appointmentReminderAppointmentIsRescheduledOnAnotherTimeConfirmByAgent: Scalars['Boolean']['output'];
  appointmentReminderCSRAcknowledgedAgentWillBeLateConfirmByAgent: Scalars['Boolean']['output'];
  appointmentReminderCreatedNewAppointmentWithAnotherAgentConfirmByAgent: Scalars['Boolean']['output'];
  appointmentReminderRequiredAgentConfirmationConfirm: Scalars['Boolean']['output'];
  appointmentReminderRequiredAgentConfirmationRescheduleOnAnotherAgent: Scalars['Boolean']['output'];
  appointmentReminderRequiredAgentConfirmationRescheduleOnAnotherTime: Scalars['Boolean']['output'];
  appointmentReminderRequiredAgentConfirmationWillBeLate: Scalars['Boolean']['output'];
  appointmentReminderRequiredRescheduleOnAnotherAgentConfirmByCsr: Scalars['Boolean']['output'];
  appointmentReminderRequiredRescheduleOnAnotherTimeConfirmByCsr: Scalars['Boolean']['output'];
  appointmentReminderSuggestedToRescheduleAppointmentConfirmByAgent: Scalars['Boolean']['output'];
  changeEnrollmentStatus?: Maybe<Scalars['UUID']['output']>;
  changeMedigapEnrollmentStatus: Scalars['Boolean']['output'];
  changePdpEnrollmentStatus: Scalars['Boolean']['output'];
  clearFlexpaCache: Scalars['Boolean']['output'];
  clientCommunicationNoShow: Scalars['Boolean']['output'];
  confirmScopeOfAppointment: Scalars['UUID']['output'];
  createCalendarEvent: CalendarEventOutput;
  createClientNote: Scalars['Boolean']['output'];
  createScopeOfAppointment: Scalars['UUID']['output'];
  /** @deprecated Need to use saveUserProfile API */
  createUser: KeycloakUserOutput;
  deleteActionItem: Scalars['Boolean']['output'];
  deleteCalendarEvent: Scalars['Boolean']['output'];
  deleteClientFile: Scalars['Boolean']['output'];
  deleteClientNote: Scalars['Boolean']['output'];
  deleteClientsFromAnyGroup: Scalars['Boolean']['output'];
  deleteCompareOfferHistoryItem: Scalars['Boolean']['output'];
  deleteEmailTemplate: Scalars['Boolean']['output'];
  deleteEnrollment: Scalars['Boolean']['output'];
  deleteMedigapEnrollment: Scalars['Boolean']['output'];
  deleteOfflineConversionSyncProcess: Scalars['Boolean']['output'];
  deleteOfflineConversionSyncProcessBeforeDate: Scalars['Boolean']['output'];
  deletePdpEnrollment: Scalars['Boolean']['output'];
  deletePurchasedProduct: Scalars['Boolean']['output'];
  deleteTag: Scalars['Boolean']['output'];
  deleteTestClient: Scalars['Boolean']['output'];
  deleteUser: Scalars['Boolean']['output'];
  editQaReview: CallQaOutput;
  emailMeMAPage: Scalars['Boolean']['output'];
  emailMeMedigapPage: Scalars['Boolean']['output'];
  getRefreshToken: LoginResponse;
  linkAdviserWithClient: Scalars['Boolean']['output'];
  login: LoginResponse;
  markAppointmentRequestAsDone: Scalars['Boolean']['output'];
  markRequiredActionAsDone: Scalars['Boolean']['output'];
  mergeClientsInOneGroup: Scalars['Boolean']['output'];
  mergeGroups: Scalars['Boolean']['output'];
  migrateAllEnrollmentsPlanNames: EnrollmentPlanNameMigrationResult;
  migrateEnrollmentsWithBrokenAgent: Scalars['Boolean']['output'];
  migrateY2YByClientId: Scalars['Boolean']['output'];
  openedScopeOfAppointment: Scalars['Boolean']['output'];
  patchClientPersonalInfo: Scalars['Boolean']['output'];
  putTemporalData: Scalars['UUID']['output'];
  refreshDayPlan: Scalars['Boolean']['output'];
  requestUrgentCall: Scalars['Boolean']['output'];
  resetPassword: Scalars['Boolean']['output'];
  respondToCalendarEvent: CalendarEventOutput;
  saveActionItem: ActionItemOutput;
  saveAdvisorDetails: AdvisorDetailsOutput;
  saveAgent: Scalars['UUID']['output'];
  saveAgentGmailCode: Scalars['Boolean']['output'];
  saveCallHistory: Scalars['UUID']['output'];
  saveChannelAttribution: Scalars['Boolean']['output'];
  saveClientTag: Scalars['Boolean']['output'];
  saveClientTrackingId: Scalars['Boolean']['output'];
  saveClientWatchers: Scalars['Boolean']['output'];
  saveCompareOfferHistoryItem: Scalars['Boolean']['output'];
  saveDisqualifiedReason: Scalars['Boolean']['output'];
  saveEmailTemplate: Scalars['UUID']['output'];
  saveEnrollment: Scalars['UUID']['output'];
  saveExpectedCloseDate: Scalars['Boolean']['output'];
  saveFlexpaToken: Scalars['Boolean']['output'];
  saveManagerNote: Scalars['Boolean']['output'];
  saveMedigapEnrollment: Scalars['UUID']['output'];
  savePdpEnrollment: PdpEnrollmentOutput;
  savePurchasedProduct: Scalars['UUID']['output'];
  saveStatus: Scalars['Boolean']['output'];
  saveTag: Scalars['UUID']['output'];
  saveUserProfile: UserProfileSaveOutput;
  sendComparisonEmail: Scalars['Boolean']['output'];
  sendGreeting: Scalars['String']['output'];
  sendY2YEmail: Scalars['Boolean']['output'];
  setAdminFlagForAllEnrollmentsByClientId: Scalars['Boolean']['output'];
  setCalendlyAppointmentNoShow: Scalars['Boolean']['output'];
  setClientUserId: Scalars['Boolean']['output'];
  setDefaultAgent: Scalars['Boolean']['output'];
  setDontDisturb: Scalars['Boolean']['output'];
  setNewPassword: Scalars['Boolean']['output'];
  setRecordedLineAgreementCheck: Scalars['Boolean']['output'];
  setSOAAgreementCheck: Scalars['Boolean']['output'];
  setTPMOAgreementCheck: Scalars['Boolean']['output'];
  setUrgentCallRequested: Scalars['Boolean']['output'];
  startAICall: Scalars['Boolean']['output'];
  startAgentRawDigitsMigration: Scalars['Boolean']['output'];
  startTestCallFor30Seconds: Scalars['Boolean']['output'];
  stopAgentRawDigitsMigration: Scalars['Boolean']['output'];
  syncGmailMessages: Scalars['Boolean']['output'];
  syncHawksoft: Scalars['Boolean']['output'];
  syncOfflineConversions: Scalars['Boolean']['output'];
  updateCalendarEvent: CalendarEventOutput;
  updateClientNote: Scalars['Boolean']['output'];
  updateOfflineConversionSyncProcess: OfflineConversionSyncProcessOutput;
  updateRRStatus: Scalars['String']['output'];
  updateSendInBlueByEmail: Scalars['String']['output'];
  updateSources: Array<LeadSourceOutput>;
  updatedUserProfileByAdvisor: Scalars['Boolean']['output'];
  uploadAgentAvatar: Scalars['String']['output'];
};


export type MutationAddClientFilesArgs = {
  clientFiles: Array<ClientFileInput>;
  clientId: Scalars['UUID']['input'];
};


export type MutationAppointmentReminderAgentConfirmedButWillBeLateConfirmByCsrArgs = {
  id: Scalars['String']['input'];
};


export type MutationAppointmentReminderAgentIsMissingAppointmentConfirmByCsrArgs = {
  id: Scalars['String']['input'];
};


export type MutationAppointmentReminderAppointmentIsRescheduledOnAnotherTimeConfirmByAgentArgs = {
  id: Scalars['String']['input'];
};


export type MutationAppointmentReminderCsrAcknowledgedAgentWillBeLateConfirmByAgentArgs = {
  id: Scalars['String']['input'];
};


export type MutationAppointmentReminderCreatedNewAppointmentWithAnotherAgentConfirmByAgentArgs = {
  id: Scalars['String']['input'];
};


export type MutationAppointmentReminderRequiredAgentConfirmationConfirmArgs = {
  id: Scalars['String']['input'];
};


export type MutationAppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherAgentArgs = {
  id: Scalars['String']['input'];
};


export type MutationAppointmentReminderRequiredAgentConfirmationRescheduleOnAnotherTimeArgs = {
  id: Scalars['String']['input'];
};


export type MutationAppointmentReminderRequiredAgentConfirmationWillBeLateArgs = {
  id: Scalars['String']['input'];
};


export type MutationAppointmentReminderRequiredRescheduleOnAnotherAgentConfirmByCsrArgs = {
  id: Scalars['String']['input'];
};


export type MutationAppointmentReminderRequiredRescheduleOnAnotherTimeConfirmByCsrArgs = {
  id: Scalars['String']['input'];
};


export type MutationAppointmentReminderSuggestedToRescheduleAppointmentConfirmByAgentArgs = {
  id: Scalars['String']['input'];
};


export type MutationChangeEnrollmentStatusArgs = {
  enrollmentId: Scalars['UUID']['input'];
  status: EnrollmentStatusInput;
};


export type MutationChangeMedigapEnrollmentStatusArgs = {
  enrollmentId: Scalars['UUID']['input'];
  status: MedigapEnrollmentStatus;
};


export type MutationChangePdpEnrollmentStatusArgs = {
  enrollmentId: Scalars['UUID']['input'];
  status: PdpEnrollmentStatus;
};


export type MutationClientCommunicationNoShowArgs = {
  clientId: Scalars['UUID']['input'];
};


export type MutationConfirmScopeOfAppointmentArgs = {
  userInput: ScopeOfAppointmentUserInput;
};


export type MutationCreateCalendarEventArgs = {
  agentEmail?: InputMaybe<Scalars['String']['input']>;
  input: CreateCalendarEventInput;
};


export type MutationCreateClientNoteArgs = {
  clientId: Scalars['UUID']['input'];
  isManagerNote?: InputMaybe<Scalars['Boolean']['input']>;
  note: Scalars['String']['input'];
};


export type MutationCreateScopeOfAppointmentArgs = {
  adminInput: ScopeOfAppointmentAdminInput;
};


export type MutationCreateUserArgs = {
  input: KeycloakUserInput;
};


export type MutationDeleteActionItemArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteCalendarEventArgs = {
  agentEmail?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['String']['input'];
};


export type MutationDeleteClientFileArgs = {
  clientId: Scalars['UUID']['input'];
  link: Scalars['String']['input'];
};


export type MutationDeleteClientNoteArgs = {
  noteId: Scalars['UUID']['input'];
};


export type MutationDeleteClientsFromAnyGroupArgs = {
  clientIds: Array<Scalars['UUID']['input']>;
};


export type MutationDeleteCompareOfferHistoryItemArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteEmailTemplateArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteEnrollmentArgs = {
  enrollmentId: Scalars['UUID']['input'];
};


export type MutationDeleteMedigapEnrollmentArgs = {
  medigapEnrollmentId: Scalars['UUID']['input'];
};


export type MutationDeleteOfflineConversionSyncProcessArgs = {
  id: Scalars['Long']['input'];
};


export type MutationDeleteOfflineConversionSyncProcessBeforeDateArgs = {
  beforeDate: Scalars['LocalDate']['input'];
};


export type MutationDeletePdpEnrollmentArgs = {
  enrollmentId: Scalars['UUID']['input'];
};


export type MutationDeletePurchasedProductArgs = {
  purchasedProductId: Scalars['UUID']['input'];
};


export type MutationDeleteTagArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteTestClientArgs = {
  email: Scalars['String']['input'];
};


export type MutationEditQaReviewArgs = {
  airCallId: Scalars['Long']['input'];
  editedAuditSheet?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  overriddenScore?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationEmailMeMaPageArgs = {
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  yearEmailMeMaPage?: InputMaybe<EmailMeMaPagePlanYear>;
};


export type MutationEmailMeMedigapPageArgs = {
  email: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
};


export type MutationLinkAdviserWithClientArgs = {
  email: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationMarkAppointmentRequestAsDoneArgs = {
  appointmentRequestId: Scalars['UUID']['input'];
};


export type MutationMarkRequiredActionAsDoneArgs = {
  agentId: Scalars['String']['input'];
};


export type MutationMergeClientsInOneGroupArgs = {
  clientIds: Array<Scalars['UUID']['input']>;
};


export type MutationMergeGroupsArgs = {
  groupIds: Array<Scalars['UUID']['input']>;
};


export type MutationMigrateEnrollmentsWithBrokenAgentArgs = {
  key: Scalars['String']['input'];
};


export type MutationMigrateY2YByClientIdArgs = {
  clientId: Scalars['UUID']['input'];
};


export type MutationOpenedScopeOfAppointmentArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationPatchClientPersonalInfoArgs = {
  clientId: Scalars['UUID']['input'];
  drugDeliveryType?: InputMaybe<ClientDrugDeliveryType>;
  preferredDrugs?: InputMaybe<Array<PreferredDrugInput>>;
  preferredPharmacies?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationPutTemporalDataArgs = {
  data: Scalars['String']['input'];
};


export type MutationRefreshDayPlanArgs = {
  message?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestUrgentCallArgs = {
  urgentCallType: UrgentCallTypeDto;
};


export type MutationResetPasswordArgs = {
  clientId: Scalars['UUID']['input'];
};


export type MutationRespondToCalendarEventArgs = {
  agentEmail?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['String']['input'];
  response: CalendarEventResponse;
};


export type MutationSaveActionItemArgs = {
  input: ActionItemInput;
};


export type MutationSaveAdvisorDetailsArgs = {
  input: AdvisorDetailsInput;
};


export type MutationSaveAgentArgs = {
  input: AgentInput;
};


export type MutationSaveAgentGmailCodeArgs = {
  code: Scalars['String']['input'];
};


export type MutationSaveCallHistoryArgs = {
  input: CallHistoryInput;
};


export type MutationSaveChannelAttributionArgs = {
  clientId: Scalars['UUID']['input'];
  marketingCampaign?: InputMaybe<Scalars['String']['input']>;
  marketingSource?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSaveClientTagArgs = {
  input: ClientTagInput;
};


export type MutationSaveClientTrackingIdArgs = {
  input: ClientTrackingIdDtoInput;
};


export type MutationSaveClientWatchersArgs = {
  input: ClientWatcherInput;
};


export type MutationSaveCompareOfferHistoryItemArgs = {
  input: CompareOfferHistoryInput;
};


export type MutationSaveDisqualifiedReasonArgs = {
  disqualifiedReason: DisqualifiedReasonDto;
  id: Scalars['UUID']['input'];
};


export type MutationSaveEmailTemplateArgs = {
  emailTemplate: EmailTemplateDtoInput;
};


export type MutationSaveEnrollmentArgs = {
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  input: EnrollmentInput;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationSaveExpectedCloseDateArgs = {
  expectedCloseDate: Scalars['LocalDate']['input'];
  id: Scalars['UUID']['input'];
};


export type MutationSaveFlexpaTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationSaveManagerNoteArgs = {
  clientId: Scalars['UUID']['input'];
  managerNote: Scalars['String']['input'];
};


export type MutationSaveMedigapEnrollmentArgs = {
  input: MedigapEnrollmentInput;
};


export type MutationSavePdpEnrollmentArgs = {
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  input: PdpEnrollmentInput;
};


export type MutationSavePurchasedProductArgs = {
  input: PurchasedProductInput;
};


export type MutationSaveStatusArgs = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
  followUpDate?: InputMaybe<Scalars['LocalDate']['input']>;
  id: Scalars['UUID']['input'];
  status: StatusDto;
};


export type MutationSaveTagArgs = {
  input: TagInput;
};


export type MutationSaveUserProfileArgs = {
  input: UserProfileInput;
};


export type MutationSendComparisonEmailArgs = {
  clientId: Scalars['UUID']['input'];
  link: Scalars['String']['input'];
};


export type MutationSendGreetingArgs = {
  message: Scalars['String']['input'];
};


export type MutationSendY2YEmailArgs = {
  clientId: Scalars['UUID']['input'];
  image: Scalars['Upload']['input'];
};


export type MutationSetAdminFlagForAllEnrollmentsByClientIdArgs = {
  clientId: Scalars['UUID']['input'];
};


export type MutationSetCalendlyAppointmentNoShowArgs = {
  id: Scalars['String']['input'];
  noShow: Scalars['Boolean']['input'];
};


export type MutationSetClientUserIdArgs = {
  clientId: Scalars['UUID']['input'];
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationSetDefaultAgentArgs = {
  agentId: Scalars['UUID']['input'];
};


export type MutationSetDontDisturbArgs = {
  dontDisturb: Scalars['Boolean']['input'];
};


export type MutationSetNewPasswordArgs = {
  newPassword: Scalars['String']['input'];
};


export type MutationSetRecordedLineAgreementCheckArgs = {
  clientId: Scalars['UUID']['input'];
};


export type MutationSetSoaAgreementCheckArgs = {
  clientId: Scalars['UUID']['input'];
};


export type MutationSetTpmoAgreementCheckArgs = {
  clientId: Scalars['UUID']['input'];
};


export type MutationSetUrgentCallRequestedArgs = {
  clientId: Scalars['UUID']['input'];
  urgentCallRequested: Scalars['Boolean']['input'];
};


export type MutationStartAiCallArgs = {
  clientId: Scalars['UUID']['input'];
};


export type MutationStartAgentRawDigitsMigrationArgs = {
  key: Scalars['String']['input'];
};


export type MutationStartTestCallFor30SecondsArgs = {
  agentId: Scalars['UUID']['input'];
  airCallId?: InputMaybe<Scalars['Long']['input']>;
  clientId: Scalars['UUID']['input'];
};


export type MutationStopAgentRawDigitsMigrationArgs = {
  key: Scalars['String']['input'];
};


export type MutationSyncGmailMessagesArgs = {
  code: Scalars['String']['input'];
};


export type MutationSyncHawksoftArgs = {
  secret: Scalars['String']['input'];
};


export type MutationUpdateCalendarEventArgs = {
  agentEmail?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['String']['input'];
  input: UpdateCalendarEventInput;
};


export type MutationUpdateClientNoteArgs = {
  note: Scalars['String']['input'];
  noteId: Scalars['UUID']['input'];
};


export type MutationUpdateOfflineConversionSyncProcessArgs = {
  input: OfflineConversionSyncProcessUpdateInput;
};


export type MutationUpdateRrStatusArgs = {
  enabled: Scalars['Boolean']['input'];
  secret: Scalars['String']['input'];
};


export type MutationUpdateSendInBlueByEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationUpdateSourcesArgs = {
  clientId: Scalars['UUID']['input'];
};


export type MutationUpdatedUserProfileByAdvisorArgs = {
  clientId: Scalars['UUID']['input'];
  input: UserProfileInputForAdviserInput;
};


export type MutationUploadAgentAvatarArgs = {
  img: Scalars['Upload']['input'];
};

export type NetworkInfoViewOutput = {
  __typename?: 'NetworkInfoViewOutput';
  carrierName: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type NewLeadsStatisticsOutput = {
  __typename?: 'NewLeadsStatisticsOutput';
  count: Scalars['Int']['output'];
  nerdWalletCount: Scalars['Int']['output'];
  oldestCreatedAt?: Maybe<Scalars['Instant']['output']>;
};

export type OfflineConversionSyncProcessFilterInput = {
  createdAtFrom?: InputMaybe<Scalars['Instant']['input']>;
  createdAtTo?: InputMaybe<Scalars['Instant']['input']>;
  eventName?: InputMaybe<EventName>;
  hasError?: InputMaybe<Scalars['Boolean']['input']>;
  platform?: InputMaybe<Platform>;
  synced?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OfflineConversionSyncProcessOutput = {
  __typename?: 'OfflineConversionSyncProcessOutput';
  cId?: Maybe<Scalars['String']['output']>;
  clientId: Scalars['UUID']['output'];
  conversionTime: Scalars['Instant']['output'];
  createdAt: Scalars['Instant']['output'];
  errorMsg?: Maybe<Scalars['String']['output']>;
  eventName: EventName;
  fbclid?: Maybe<Scalars['String']['output']>;
  gbraid?: Maybe<Scalars['String']['output']>;
  gclid?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  msclkid?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Platform>;
  synced: Scalars['Boolean']['output'];
  uId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Instant']['output'];
  utmBrand?: Maybe<Scalars['String']['output']>;
  utmCampaign?: Maybe<Scalars['String']['output']>;
  utmContent?: Maybe<Scalars['String']['output']>;
  utmMedium?: Maybe<Scalars['String']['output']>;
  utmSource?: Maybe<Scalars['String']['output']>;
  utmTerm?: Maybe<Scalars['String']['output']>;
  version: Scalars['Long']['output'];
  wbraid?: Maybe<Scalars['String']['output']>;
};

export type OfflineConversionSyncProcessUpdateInput = {
  eventName?: InputMaybe<EventName>;
  fbclid?: InputMaybe<Scalars['String']['input']>;
  gbraid?: InputMaybe<Scalars['String']['input']>;
  gclid?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Long']['input'];
  msclkid?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Platform>;
  utmBrand?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
  wbraid?: InputMaybe<Scalars['String']['input']>;
};

export type OverdueItemOutput = {
  __typename?: 'OverdueItemOutput';
  clientId: Scalars['UUID']['output'];
  detail?: Maybe<Scalars['String']['output']>;
  expectedCloseDate?: Maybe<Scalars['LocalDate']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  followUpDate?: Maybe<Scalars['LocalDate']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type PageInput = {
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
};

export type PageableActionItemOutput = {
  __typename?: 'PageableActionItemOutput';
  data: Array<ActionItemOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PageableAgentOutput = {
  __typename?: 'PageableAgentOutput';
  data: Array<AgentOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PageableAttemptedLeadOutput = {
  __typename?: 'PageableAttemptedLeadOutput';
  data: Array<AttemptedLeadOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PageableCalendlyAppointmentsOutput = {
  __typename?: 'PageableCalendlyAppointmentsOutput';
  data: Array<AppointmentOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PageableCallHistoryOutput = {
  __typename?: 'PageableCallHistoryOutput';
  data: Array<CallHistoryOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PageableClientViewForAdviserOutput = {
  __typename?: 'PageableClientViewForAdviserOutput';
  data: Array<ClientViewForAdviserOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PageableClientViewListRepresentationOutput = {
  __typename?: 'PageableClientViewListRepresentationOutput';
  data: Array<ClientViewListRepresentationOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PageableEmailTemplateOutput = {
  __typename?: 'PageableEmailTemplateOutput';
  data: Array<EmailTemplateDto>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PageableEnrollmentListItemOutput = {
  __typename?: 'PageableEnrollmentListItemOutput';
  data: Array<EnrollmentListItemOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PageableEnrollmentOutput = {
  __typename?: 'PageableEnrollmentOutput';
  data: Array<EnrollmentOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PageableMedigapEnrollmentOutput = {
  __typename?: 'PageableMedigapEnrollmentOutput';
  data: Array<MedigapEnrollmentOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PageableOfflineConversionSyncProcessOutput = {
  __typename?: 'PageableOfflineConversionSyncProcessOutput';
  data: Array<OfflineConversionSyncProcessOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PageablePdpEnrollmentOutput = {
  __typename?: 'PageablePdpEnrollmentOutput';
  data: Array<PdpEnrollmentOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PageableQaAuditOutput = {
  __typename?: 'PageableQaAuditOutput';
  data: Array<QaCallRowOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PageableSlaOutput = {
  __typename?: 'PageableSLAOutput';
  data: Array<SlaOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PageableUserProfileOutput = {
  __typename?: 'PageableUserProfileOutput';
  data: Array<UserProfileOutput>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  isFirst: Scalars['Boolean']['output'];
  isLast: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Long']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PartnerApiUsageDto = {
  __typename?: 'PartnerAPIUsageDto';
  lastCreatedAt?: Maybe<Scalars['Instant']['output']>;
  totalCount: Scalars['Long']['output'];
};

export type PartnersApiUsageResult = {
  __typename?: 'PartnersAPIUsageResult';
  alpineDigitalGroup: PartnerApiUsageDto;
  leadEconomy: PartnerApiUsageDto;
  quinStreet: PartnerApiUsageDto;
  revriseMedia: PartnerApiUsageDto;
};

export type PcpInfoViewOutput = {
  __typename?: 'PcpInfoViewOutput';
  id?: Maybe<Scalars['UUID']['output']>;
  networkDetails: Array<NetworkInfoViewOutput>;
  pcpId: Scalars['String']['output'];
};

export type PdpEnrollmentInput = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
  applicationDate?: InputMaybe<Scalars['LocalDate']['input']>;
  birthDate?: InputMaybe<Scalars['LocalDate']['input']>;
  cId?: InputMaybe<Scalars['String']['input']>;
  carrierName?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['LocalDate']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enrollmentType?: InputMaybe<PdpEnrollmentType>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  insulinSavings?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  planId: Scalars['String']['input'];
  planName?: InputMaybe<Scalars['String']['input']>;
  planYear?: InputMaybe<PlanYear>;
  started?: InputMaybe<Scalars['Instant']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type PdpEnrollmentOutput = {
  __typename?: 'PdpEnrollmentOutput';
  agentId?: Maybe<Scalars['UUID']['output']>;
  applicationDate?: Maybe<Scalars['LocalDate']['output']>;
  approvedAt?: Maybe<Scalars['Instant']['output']>;
  birthDate?: Maybe<Scalars['LocalDate']['output']>;
  cId?: Maybe<Scalars['String']['output']>;
  carrierName?: Maybe<Scalars['String']['output']>;
  clientId: Scalars['UUID']['output'];
  county?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['LocalDate']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enrollmentType?: Maybe<PdpEnrollmentType>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  insulinSavings?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  pdpQuoteId?: Maybe<Scalars['UUID']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  planId: Scalars['String']['output'];
  planName?: Maybe<Scalars['String']['output']>;
  planYear?: Maybe<PlanYear>;
  started?: Maybe<Scalars['Instant']['output']>;
  status: PdpEnrollmentStatus;
  zip?: Maybe<Scalars['String']['output']>;
};

export enum PdpEnrollmentStatus {
  Draft = 'DRAFT',
  Enrolled = 'ENROLLED',
  New = 'NEW',
  Rejected = 'REJECTED',
  Sent = 'SENT'
}

export enum PdpEnrollmentType {
  PdpNew = 'PDP_NEW',
  PdpReplacement = 'PDP_REPLACEMENT',
  PdpUnlikeChange = 'PDP_UNLIKE_CHANGE'
}

export type PdpEnrollmentViewOutput = {
  __typename?: 'PdpEnrollmentViewOutput';
  birthDate?: Maybe<Scalars['LocalDate']['output']>;
  cId?: Maybe<Scalars['String']['output']>;
  clientId: Scalars['UUID']['output'];
  createdAt: Scalars['Instant']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  insulinSavings?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  pdpQuoteId?: Maybe<Scalars['UUID']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  planId: Scalars['String']['output'];
  updatedAt: Scalars['Instant']['output'];
  userId?: Maybe<Scalars['UUID']['output']>;
};

export type PdpFilterInput = {
  isImported?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PdpQuoteOutput = {
  __typename?: 'PdpQuoteOutput';
  cId?: Maybe<Scalars['String']['output']>;
  clientId: Scalars['UUID']['output'];
  countyName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Instant']['output'];
  id: Scalars['UUID']['output'];
  insulinSavings?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['Instant']['output'];
  userId?: Maybe<Scalars['UUID']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type PlanSectionOutput = {
  __typename?: 'PlanSectionOutput';
  planId: Scalars['UUID']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  targetDate: Scalars['LocalDate']['output'];
  tasks: Array<PlanTaskOutput>;
};

export type PlanTaskOutput = {
  __typename?: 'PlanTaskOutput';
  actionItemId?: Maybe<Scalars['UUID']['output']>;
  actionVerb?: Maybe<Scalars['String']['output']>;
  airCallId?: Maybe<Scalars['Long']['output']>;
  calendarEventId?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['UUID']['output']>;
  done: Scalars['Boolean']['output'];
  durationMinutes?: Maybe<Scalars['Int']['output']>;
  floating: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  ordinal: Scalars['Int']['output'];
  reasonText?: Maybe<Scalars['String']['output']>;
  sla?: Maybe<Scalars['String']['output']>;
  slotEnd?: Maybe<Scalars['String']['output']>;
  slotStart?: Maybe<Scalars['String']['output']>;
  taskType: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum PlanYear {
  Year2021 = 'Year2021',
  Year2022 = 'Year2022',
  Year2023 = 'Year2023',
  Year2024 = 'Year2024',
  Year2025 = 'Year2025',
  Year2026 = 'Year2026'
}

export enum Platform {
  GoogleCaliburn = 'GOOGLE_CALIBURN',
  GoogleCoverright = 'GOOGLE_COVERRIGHT',
  MetaCoverright = 'META_COVERRIGHT',
  MicrosoftCaliburn = 'MICROSOFT_CALIBURN',
  MicrosoftCoverright = 'MICROSOFT_COVERRIGHT'
}

export type PreCallBriefingOutput = {
  __typename?: 'PreCallBriefingOutput';
  callSummaries?: Maybe<Array<Scalars['String']['output']>>;
  context?: Maybe<Array<Scalars['String']['output']>>;
  emailsSummary?: Maybe<Array<Scalars['String']['output']>>;
  notesSummary?: Maybe<Array<Scalars['String']['output']>>;
  talkingPoints?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt?: Maybe<Scalars['Instant']['output']>;
};

export type PreferredDrugInput = {
  dosageRxcui: Scalars['String']['input'];
  frequency: CalcDrugFrequencyPeriodInput;
  productRxcui: Scalars['String']['input'];
  purchaseFrequency: FrequencyPeriodInput;
  quantity: Scalars['BigDecimal']['input'];
};

export type PreferredDrugViewOutput = {
  __typename?: 'PreferredDrugViewOutput';
  dosageRxcui: Scalars['String']['output'];
  frequency: CalcDrugFrequencyPeriodViewOutput;
  productRxcui: Scalars['String']['output'];
  purchaseFrequency: FrequencyPeriodViewOutput;
  quantity: Scalars['BigDecimal']['output'];
};

export enum PreferredLanguageDto {
  Chinese = 'CHINESE',
  English = 'ENGLISH',
  French = 'FRENCH',
  FrenchCreole = 'FRENCH_CREOLE',
  Korean = 'KOREAN',
  Polish = 'POLISH',
  Spanish = 'SPANISH',
  Vietnamese = 'VIETNAMESE'
}

export type ProfileAttributeInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum ProfileOption {
  CreateEnrollment = 'CREATE_ENROLLMENT',
  RegisterUser = 'REGISTER_USER',
  RequestCall = 'REQUEST_CALL',
  SetAttributes = 'SET_ATTRIBUTES',
  UnsupportedZip = 'UNSUPPORTED_ZIP'
}

export enum ProfileSource {
  ApplicationOnboarding = 'APPLICATION_ONBOARDING',
  B2B = 'B2B',
  BlueInk = 'BLUE_INK',
  CallRequest = 'CALL_REQUEST',
  DrugOptimizer = 'DRUG_OPTIMIZER',
  EnrollmentForm = 'ENROLLMENT_FORM',
  FinancialAdvisor = 'FINANCIAL_ADVISOR',
  ForbesOnboarding = 'FORBES_ONBOARDING',
  MaMarketplace = 'MA_MARKETPLACE',
  MedicarecOnboarding = 'MEDICAREC_ONBOARDING',
  MgMarketplace = 'MG_MARKETPLACE',
  OutOfService = 'OUT_OF_SERVICE',
  PdpMarketplace = 'PDP_MARKETPLACE',
  RenegadeOnboarding = 'RENEGADE_ONBOARDING',
  ScheduleOnboarding = 'SCHEDULE_ONBOARDING',
  ShortForm = 'SHORT_FORM',
  UhcOnboarding = 'UHC_ONBOARDING',
  UserFlowV1 = 'USER_FLOW_V1',
  UserFlowV1_5 = 'USER_FLOW_V1_5',
  UserFlowV2 = 'USER_FLOW_V2'
}

export type PurchasedProductInput = {
  clientId: Scalars['UUID']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isPrimaryPerson: Scalars['Boolean']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  type: CoverRightProductDto;
};

export type PurchasedProductOutput = {
  __typename?: 'PurchasedProductOutput';
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isPrimaryPerson: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  type: CoverRightProductDto;
};

export type QaCallRowOutput = {
  __typename?: 'QaCallRowOutput';
  agentId?: Maybe<Scalars['UUID']['output']>;
  agentName?: Maybe<Scalars['String']['output']>;
  airCallId: Scalars['Long']['output'];
  callDate?: Maybe<Scalars['Instant']['output']>;
  clientId: Scalars['UUID']['output'];
  clientName?: Maybe<Scalars['String']['output']>;
  dispositionClass: Scalars['String']['output'];
  effectiveScore?: Maybe<Scalars['Int']['output']>;
  isEnrollmentCall: Scalars['Boolean']['output'];
  wasOverridden: Scalars['Boolean']['output'];
};

export type QaCategoryDeltaOutput = {
  __typename?: 'QaCategoryDeltaOutput';
  category: Scalars['String']['output'];
  delta: Scalars['Int']['output'];
  groupA: Scalars['Int']['output'];
  groupB: Scalars['Int']['output'];
};

export type QaCategoryStatOutput = {
  __typename?: 'QaCategoryStatOutput';
  callsApplicable: Scalars['Int']['output'];
  category: Scalars['String']['output'];
  pointsLost: Scalars['Int']['output'];
};

export type QaCompareGroupInput = {
  agentIds: Array<Scalars['UUID']['input']>;
  label: Scalars['String']['input'];
};

export type QaCompareGroupOutput = {
  __typename?: 'QaCompareGroupOutput';
  label: Scalars['String']['output'];
  report: AgentQaReportOutput;
};

export type QaCompareOutput = {
  __typename?: 'QaCompareOutput';
  comparison?: Maybe<QaComparisonOutput>;
  groups: Array<QaCompareGroupOutput>;
};

export type QaComparisonOutput = {
  __typename?: 'QaComparisonOutput';
  categoryDeltas: Array<QaCategoryDeltaOutput>;
  questionDeltas: Array<QaQuestionDeltaOutput>;
  scoreDelta: Scalars['Float']['output'];
};

export type QaQuestionDeltaOutput = {
  __typename?: 'QaQuestionDeltaOutput';
  delta: Scalars['Float']['output'];
  groupAFailRate: Scalars['Float']['output'];
  groupBFailRate: Scalars['Float']['output'];
  questionId: Scalars['String']['output'];
};

export type QaQuestionOutput = {
  __typename?: 'QaQuestionOutput';
  answer: Scalars['String']['output'];
  category: Scalars['String']['output'];
  deductionApplied: Scalars['Int']['output'];
  evidence?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  maxDeduction: Scalars['Int']['output'];
  question: Scalars['String']['output'];
  sourceAirCallId?: Maybe<Scalars['String']['output']>;
};

export type QaQuestionPerAgentOutput = {
  __typename?: 'QaQuestionPerAgentOutput';
  agentId?: Maybe<Scalars['UUID']['output']>;
  agentName?: Maybe<Scalars['String']['output']>;
  failRate: Scalars['Float']['output'];
};

export type QaQuestionPerformanceOutput = {
  __typename?: 'QaQuestionPerformanceOutput';
  excludedNA: Scalars['Int']['output'];
  failRate: Scalars['Float']['output'];
  perAgent: Array<QaQuestionPerAgentOutput>;
  pointsLost: Scalars['Int']['output'];
  questionId: Scalars['String']['output'];
  totalApplicable: Scalars['Int']['output'];
  trend: Array<QaTrendPointOutput>;
};

export type QaQuestionStatOutput = {
  __typename?: 'QaQuestionStatOutput';
  applicableCount: Scalars['Int']['output'];
  failCount: Scalars['Int']['output'];
  failRate: Scalars['Float']['output'];
  question: Scalars['String']['output'];
  questionId: Scalars['String']['output'];
};

export type QaSummaryOutput = {
  __typename?: 'QaSummaryOutput';
  averageScore: Scalars['Float']['output'];
  bestScore?: Maybe<Scalars['Int']['output']>;
  callsScored: Scalars['Int']['output'];
  enrollmentCalls: Scalars['Int']['output'];
  trend: Array<QaTrendPointOutput>;
  worstScore?: Maybe<Scalars['Int']['output']>;
};

export type QaTrendPointOutput = {
  __typename?: 'QaTrendPointOutput';
  averageScore: Scalars['Float']['output'];
  callsScored: Scalars['Int']['output'];
  periodStart: Scalars['Instant']['output'];
};

export type Query = {
  __typename?: 'Query';
  actionItem: ActionItemOutput;
  actionItems: PageableActionItemOutput;
  actionItemsByClientId: Array<ActionItemOutput>;
  actionItemsSpikyMigrationProgress?: Maybe<Scalars['Int']['output']>;
  activeAppointmentRequestByClientId?: Maybe<AppointmentRequestOutput>;
  activeAppointmentRequests: Array<AppointmentRequestOutput>;
  advisorDetails?: Maybe<AdvisorDetailsOutput>;
  affiliationPartnerships: Array<AffiliationPartnershipOutput>;
  agentAssignedToClient: AgentViewOutput;
  agentAvailabilityInsights: SchedulingInsightsOutput;
  agentByContext: AgentOutput;
  agentById: AgentOutput;
  agentCurrentClientsMetrics: Array<AgentCurrentClientsMetricsOutput>;
  agentGmailAuthUrl: Scalars['String']['output'];
  agentGmailMessages: AgentEmailPageOutput;
  agentPerformanceAnalytics: Array<AgentPerformanceMetricOutput>;
  agentWorkingHours: Array<AgentWorkingHoursOutput>;
  agents: PageableAgentOutput;
  allEnrollments: PageableEnrollmentListItemOutput;
  assignmentHistory: Array<AssignmentHistoryOutput>;
  attemptedLeads: PageableAttemptedLeadOutput;
  availableAgents: Array<AgentViewOutput>;
  calendarEvent: CalendarEventOutput;
  calendarEvents: CalendarEventsOutput;
  calendarFreeBusy: Array<FreeBusyOutput>;
  calendlyAppointmentsByAgent: PageableCalendlyAppointmentsOutput;
  calendlyInvitee: InviteePersonalInfoOutput;
  callHistoryAIAnalysis?: Maybe<CallHistoryAiAnalysisOutput>;
  callHistoryAIAnalysisByClient: Array<CallHistoryAiAnalysisOutput>;
  callHistoryByAirCallId?: Maybe<CallHistoryOutput>;
  callHistoryItems: PageableCallHistoryOutput;
  checkUserExistenceByEmail: Scalars['Boolean']['output'];
  clientCalendlyAppointments: Array<AppointmentOutput>;
  clientGroupByClientId?: Maybe<ClientGroupOutput>;
  clientIdByProfileId: Scalars['UUID']['output'];
  clientLeadSources: Array<LeadSourceOutput>;
  clientMedigapEnrollments: Array<MedigapEnrollmentOutput>;
  clientPdpEnrollments: Array<PdpEnrollmentOutput>;
  clientViewById?: Maybe<ClientViewOutput>;
  clientViewByPin?: Maybe<ClientViewOutput>;
  clientViewForAdviser?: Maybe<ClientViewForAdviserOutput>;
  clientViews: PageableClientViewListRepresentationOutput;
  clientViewsForAdviser: PageableClientViewForAdviserOutput;
  compareOfferHistory: Array<CompareOfferHistoryOutput>;
  contacted: PageableClientViewListRepresentationOutput;
  continueDrugCostActivationLinkSyncCustomerIo: Scalars['Boolean']['output'];
  continueSyncCustomerIo: Scalars['Boolean']['output'];
  csrCalendlyAppointments: Array<AppointmentOutput>;
  csrTrackingReport: Array<CsrTrackingReportOutput>;
  drugCostActivationLink: Scalars['String']['output'];
  drugCostsStatusMessage?: Maybe<Scalars['String']['output']>;
  emailTemplate: EmailTemplateDto;
  emailTemplates: PageableEmailTemplateOutput;
  enrollments: PageableEnrollmentOutput;
  flexpaFHIRResource: Scalars['String']['output'];
  followUps: PageableClientViewListRepresentationOutput;
  followUpsFuture: PageableClientViewListRepresentationOutput;
  getMyEnrollment?: Maybe<EnrollmentOutput>;
  getMyMedigapEnrollments?: Maybe<MedigapEnrollmentOutput>;
  gmailMessage: AgentEmailOutput;
  gmailMessagesByClient: Array<AgentEmailOutput>;
  gmailMessagesByEmail: Array<AgentEmailOutput>;
  hasEnrollments: Scalars['Boolean']['output'];
  isAgentGmailSetUp: Scalars['Boolean']['output'];
  isFlexpaConnected: Scalars['Boolean']['output'];
  isPhoneValid: Scalars['Boolean']['output'];
  isReplayAssignmentHistoryRunning: Scalars['Boolean']['output'];
  medigapEnrollments: PageableMedigapEnrollmentOutput;
  migrateAgentRawDigitsState: MigrateAgentRawDigitsState;
  myClientId: Scalars['UUID']['output'];
  myEnrollments: Array<EnrollmentListItemOutput>;
  nerdWalletUserProfile?: Maybe<UserProfileOutput>;
  offlineConversionSyncProcesses: PageableOfflineConversionSyncProcessOutput;
  partnersAPIUsage: PartnersApiUsageResult;
  pdpEnrollment: PdpEnrollmentOutput;
  pdpEnrollments: PageablePdpEnrollmentOutput;
  pushTemporalData?: Maybe<Scalars['String']['output']>;
  qaAgentReports: Array<AgentQaReportOutput>;
  qaAudits: PageableQaAuditOutput;
  qaByAgent: AgentQaReportOutput;
  qaByClient: ClientQaReportOutput;
  qaCompare: QaCompareOutput;
  qaQuestionPerformance: QaQuestionPerformanceOutput;
  replayAssignmentHistoryProcessedCount: Scalars['Int']['output'];
  runActionItemsSpikyMigration: Scalars['Boolean']['output'];
  runClientDrugCostJob: Scalars['Boolean']['output'];
  runReplayAssignmentHistory: Scalars['Boolean']['output'];
  runReplayAssignmentHistoryForClient: Scalars['Boolean']['output'];
  salesQualified: PageableClientViewListRepresentationOutput;
  salesQualifiedFuture: PageableClientViewListRepresentationOutput;
  scopeOfAppointment?: Maybe<ScopeOfAppointmentOutput>;
  sendInBlueHistoryByEmail: SendInBlueContactWithHistory;
  shortenedCostActivationLink?: Maybe<Scalars['String']['output']>;
  startSyncCustomerIo: Scalars['Boolean']['output'];
  startSyncDrugCostActivationLinkCustomerIo: Scalars['Boolean']['output'];
  stopDrugCostActivationLinkSyncCustomerIo: Scalars['Boolean']['output'];
  stopSyncCpausedustomerIo: Scalars['Boolean']['output'];
  syncDrugCostActivationLinkByClientId: Scalars['Boolean']['output'];
  syncedCountSyncCustomerIo: Scalars['Int']['output'];
  syncedDrugCostActivationLinkCountSyncCustomerIo: Scalars['Int']['output'];
  tag: TagOutput;
  tags: Array<TagOutput>;
  userProfile?: Maybe<UserProfileOutput>;
  userProfiles: PageableUserProfileOutput;
};


export type QueryActionItemArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryActionItemsArgs = {
  filter: ActionItemFilterInput;
  pageInput: PageInput;
  sort?: InputMaybe<ActionItemSortInput>;
};


export type QueryActionItemsByClientIdArgs = {
  clientId: Scalars['UUID']['input'];
};


export type QueryActionItemsSpikyMigrationProgressArgs = {
  key: Scalars['String']['input'];
};


export type QueryActiveAppointmentRequestByClientIdArgs = {
  clientId: Scalars['UUID']['input'];
};


export type QueryAgentAssignedToClientArgs = {
  clientId: Scalars['UUID']['input'];
};


export type QueryAgentAvailabilityInsightsArgs = {
  agentEmails: Array<Scalars['String']['input']>;
  date: Scalars['LocalDate']['input'];
  minBlockMinutes: Scalars['Int']['input'];
};


export type QueryAgentByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryAgentCurrentClientsMetricsArgs = {
  filter: AgentCurrentClientsMetricsFilterInput;
};


export type QueryAgentGmailMessagesArgs = {
  agentId: Scalars['UUID']['input'];
  page: PageInput;
};


export type QueryAgentPerformanceAnalyticsArgs = {
  agentId: Scalars['UUID']['input'];
};


export type QueryAgentWorkingHoursArgs = {
  agentEmail: Scalars['String']['input'];
};


export type QueryAgentsArgs = {
  filter: AgentFilterInput;
  page: PageInput;
  sort?: InputMaybe<AgentSortInput>;
};


export type QueryAllEnrollmentsArgs = {
  filter: AllEnrollmentsFilterInput;
  page: PageInput;
};


export type QueryAssignmentHistoryArgs = {
  clientId: Scalars['UUID']['input'];
};


export type QueryAttemptedLeadsArgs = {
  filter: AttemptedLeadFilterInput;
  pageInput: PageInput;
  sort?: InputMaybe<AttemptedLeadSortInput>;
};


export type QueryCalendarEventArgs = {
  agentEmail?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['String']['input'];
};


export type QueryCalendarEventsArgs = {
  agentEmail?: InputMaybe<Scalars['String']['input']>;
  input: ListCalendarEventsInput;
};


export type QueryCalendarFreeBusyArgs = {
  agentEmails: Array<Scalars['String']['input']>;
  timeMax: Scalars['Instant']['input'];
  timeMin: Scalars['Instant']['input'];
};


export type QueryCalendlyAppointmentsByAgentArgs = {
  agentId: Scalars['UUID']['input'];
  filter: CalendlyAppointmentsFilterInput;
  pageInput: PageInput;
  sort: CalendlyAppointmentsSortInput;
};


export type QueryCalendlyInviteeArgs = {
  eventUrl: Scalars['String']['input'];
  inviteeUrl: Scalars['String']['input'];
};


export type QueryCallHistoryAiAnalysisArgs = {
  callHistory: Scalars['UUID']['input'];
};


export type QueryCallHistoryAiAnalysisByClientArgs = {
  client: Scalars['UUID']['input'];
};


export type QueryCallHistoryByAirCallIdArgs = {
  airCallId: Scalars['Long']['input'];
};


export type QueryCallHistoryItemsArgs = {
  clientId: Scalars['UUID']['input'];
  page: PageInput;
};


export type QueryCheckUserExistenceByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryClientCalendlyAppointmentsArgs = {
  clientId: Scalars['UUID']['input'];
};


export type QueryClientGroupByClientIdArgs = {
  clientId: Scalars['UUID']['input'];
};


export type QueryClientIdByProfileIdArgs = {
  profileId: Scalars['UUID']['input'];
};


export type QueryClientLeadSourcesArgs = {
  clientId: Scalars['UUID']['input'];
};


export type QueryClientMedigapEnrollmentsArgs = {
  clientId: Scalars['UUID']['input'];
};


export type QueryClientPdpEnrollmentsArgs = {
  clientId: Scalars['UUID']['input'];
};


export type QueryClientViewByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryClientViewByPinArgs = {
  pin: Scalars['String']['input'];
};


export type QueryClientViewForAdviserArgs = {
  clientId: Scalars['UUID']['input'];
};


export type QueryClientViewsArgs = {
  filterInput?: InputMaybe<ClientViewFilterInput>;
  pageInput: PageInput;
  sort?: InputMaybe<ClientViewSortInput>;
};


export type QueryClientViewsForAdviserArgs = {
  filterInput?: InputMaybe<ClientViewFilterInput>;
  pageInput: PageInput;
  sort?: InputMaybe<ClientViewSortInput>;
};


export type QueryCompareOfferHistoryArgs = {
  clientId: Scalars['UUID']['input'];
};


export type QueryContactedArgs = {
  agentId: Scalars['UUID']['input'];
  pageInput: PageInput;
  sort?: InputMaybe<ClientViewSortInput>;
};


export type QueryContinueDrugCostActivationLinkSyncCustomerIoArgs = {
  requestKey: Scalars['String']['input'];
};


export type QueryContinueSyncCustomerIoArgs = {
  requestKey: Scalars['String']['input'];
};


export type QueryCsrCalendlyAppointmentsArgs = {
  agentId: Scalars['UUID']['input'];
  from: Scalars['LocalDate']['input'];
  to: Scalars['LocalDate']['input'];
};


export type QueryCsrTrackingReportArgs = {
  from: Scalars['LocalDate']['input'];
  to: Scalars['LocalDate']['input'];
};


export type QueryDrugCostActivationLinkArgs = {
  shortenedUrl: Scalars['String']['input'];
};


export type QueryEmailTemplateArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryEmailTemplatesArgs = {
  pageInput: PageInput;
};


export type QueryEnrollmentsArgs = {
  input?: InputMaybe<EnrollmentFilterInput>;
  page: PageInput;
};


export type QueryFlexpaFhirResourceArgs = {
  resourceName: Scalars['String']['input'];
};


export type QueryFollowUpsArgs = {
  agentId: Scalars['UUID']['input'];
  excludedTagsIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  includedTagsIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  pageInput: PageInput;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ClientViewSortInput>;
};


export type QueryFollowUpsFutureArgs = {
  agentId: Scalars['UUID']['input'];
  excludedTagsIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  includedTagsIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  pageInput: PageInput;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ClientViewSortInput>;
};


export type QueryGmailMessageArgs = {
  messageId: Scalars['String']['input'];
};


export type QueryGmailMessagesByClientArgs = {
  clientId: Scalars['UUID']['input'];
};


export type QueryGmailMessagesByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryIsAgentGmailSetUpArgs = {
  agentId: Scalars['UUID']['input'];
};


export type QueryIsPhoneValidArgs = {
  phone: Scalars['String']['input'];
};


export type QueryIsReplayAssignmentHistoryRunningArgs = {
  key: Scalars['String']['input'];
};


export type QueryMedigapEnrollmentsArgs = {
  filter?: InputMaybe<MedigapFilterInput>;
  page: PageInput;
};


export type QueryMigrateAgentRawDigitsStateArgs = {
  key: Scalars['String']['input'];
};


export type QueryNerdWalletUserProfileArgs = {
  nerdWalletId: Scalars['String']['input'];
};


export type QueryOfflineConversionSyncProcessesArgs = {
  filter?: InputMaybe<OfflineConversionSyncProcessFilterInput>;
  page: PageInput;
};


export type QueryPartnersApiUsageArgs = {
  key: Scalars['String']['input'];
};


export type QueryPdpEnrollmentArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryPdpEnrollmentsArgs = {
  filter?: InputMaybe<PdpFilterInput>;
  page: PageInput;
};


export type QueryPushTemporalDataArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryQaAgentReportsArgs = {
  filter?: InputMaybe<CallQaFilterInput>;
};


export type QueryQaAuditsArgs = {
  filter?: InputMaybe<CallQaFilterInput>;
  page: PageInput;
};


export type QueryQaByAgentArgs = {
  agentId: Scalars['UUID']['input'];
  filter?: InputMaybe<CallQaFilterInput>;
};


export type QueryQaByClientArgs = {
  clientId: Scalars['UUID']['input'];
  filter?: InputMaybe<CallQaFilterInput>;
};


export type QueryQaCompareArgs = {
  filter?: InputMaybe<CallQaFilterInput>;
  groups: Array<QaCompareGroupInput>;
};


export type QueryQaQuestionPerformanceArgs = {
  filter?: InputMaybe<CallQaFilterInput>;
  questionId: Scalars['String']['input'];
};


export type QueryReplayAssignmentHistoryProcessedCountArgs = {
  key: Scalars['String']['input'];
};


export type QueryRunActionItemsSpikyMigrationArgs = {
  key: Scalars['String']['input'];
};


export type QueryRunClientDrugCostJobArgs = {
  key: Scalars['String']['input'];
};


export type QueryRunReplayAssignmentHistoryArgs = {
  key: Scalars['String']['input'];
};


export type QueryRunReplayAssignmentHistoryForClientArgs = {
  clientId: Scalars['UUID']['input'];
  key: Scalars['String']['input'];
};


export type QuerySalesQualifiedArgs = {
  agentId: Scalars['UUID']['input'];
  excludedTagsIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  includedTagsIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  pageInput: PageInput;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ClientViewSortInput>;
};


export type QuerySalesQualifiedFutureArgs = {
  agentId: Scalars['UUID']['input'];
  excludedTagsIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  includedTagsIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  pageInput: PageInput;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ClientViewSortInput>;
};


export type QueryScopeOfAppointmentArgs = {
  soaId: Scalars['UUID']['input'];
};


export type QuerySendInBlueHistoryByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryShortenedCostActivationLinkArgs = {
  clientId: Scalars['UUID']['input'];
};


export type QueryStartSyncCustomerIoArgs = {
  requestKey: Scalars['String']['input'];
};


export type QueryStartSyncDrugCostActivationLinkCustomerIoArgs = {
  requestKey: Scalars['String']['input'];
};


export type QueryStopDrugCostActivationLinkSyncCustomerIoArgs = {
  requestKey: Scalars['String']['input'];
};


export type QueryStopSyncCpausedustomerIoArgs = {
  requestKey: Scalars['String']['input'];
};


export type QuerySyncDrugCostActivationLinkByClientIdArgs = {
  clientId: Scalars['UUID']['input'];
  requestKey: Scalars['String']['input'];
};


export type QuerySyncedCountSyncCustomerIoArgs = {
  requestKey: Scalars['String']['input'];
};


export type QuerySyncedDrugCostActivationLinkCountSyncCustomerIoArgs = {
  requestKey: Scalars['String']['input'];
};


export type QueryTagArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryUserProfilesArgs = {
  filterInput?: InputMaybe<UserProfileFilterInput>;
  page: PageInput;
};

export type RrViewBusyAgentOutput = {
  __typename?: 'RRViewBusyAgentOutput';
  agentId: Scalars['UUID']['output'];
  assignedToClient: Scalars['Boolean']['output'];
  dontDisturb: Scalars['Boolean']['output'];
  excluded: Scalars['Boolean']['output'];
  onACall: Scalars['Boolean']['output'];
};

export type RrViewOutput = {
  __typename?: 'RRViewOutput';
  busy: Array<RrViewBusyAgentOutput>;
  inActiveQueue: Array<Scalars['UUID']['output']>;
  offline: Array<Scalars['UUID']['output']>;
  tasksWaitingPool: Array<AgentCallAgendaTaskInPoolOutput>;
};

export enum Rating {
  None = 'NONE',
  R1 = 'R1',
  R1_5 = 'R1_5',
  R2 = 'R2',
  R2_5 = 'R2_5',
  R3 = 'R3',
  R3_5 = 'R3_5',
  R4 = 'R4',
  R4_5 = 'R4_5',
  R5 = 'R5'
}

export type ReconnectItemOutput = {
  __typename?: 'ReconnectItemOutput';
  aiReason?: Maybe<Scalars['String']['output']>;
  clientId: Scalars['UUID']['output'];
  daysSinceLastContact?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  followUpDate?: Maybe<Scalars['LocalDate']['output']>;
  group: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  urgencyTier: Scalars['String']['output'];
};

export enum RequestStatusDto {
  Complete = 'COMPLETE',
  Deleted = 'DELETED',
  InProgress = 'IN_PROGRESS'
}

export type RequiredActionOutput = {
  __typename?: 'RequiredActionOutput';
  createdAt: Scalars['Instant']['output'];
  detailsJson: Scalars['String']['output'];
  done: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['Instant']['output'];
};

export type SlaFilterInput = {
  agent?: InputMaybe<Scalars['UUID']['input']>;
  excludeBadNumber?: InputMaybe<Scalars['Boolean']['input']>;
  excludeDoNotCall?: InputMaybe<Scalars['Boolean']['input']>;
  excludeNotAttempted?: InputMaybe<Scalars['Boolean']['input']>;
  justNerdWallet?: InputMaybe<Scalars['Boolean']['input']>;
  range?: InputMaybe<DateRangeInput>;
  tags?: InputMaybe<Array<Scalars['UUID']['input']>>;
  within2Hours?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SlaOutput = {
  __typename?: 'SLAOutput';
  agent?: Maybe<AgentViewOutput>;
  callsCount: Scalars['Int']['output'];
  clientId: Scalars['UUID']['output'];
  createdAt?: Maybe<Scalars['Instant']['output']>;
  firstCallAgentName?: Maybe<Scalars['String']['output']>;
  firstCallAt?: Maybe<Scalars['Instant']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  secondCallAgentName?: Maybe<Scalars['String']['output']>;
  secondCallAt?: Maybe<Scalars['Instant']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status: StatusDto;
  successfulCallsCount: Scalars['Int']['output'];
  tags: Array<AssignedTagViewOutput>;
};

export enum SnpType {
  CSnp = 'C_SNP',
  DSnp = 'D_SNP',
  ISnp = 'I_SNP'
}

export type SchedulingInsightsOutput = {
  __typename?: 'SchedulingInsightsOutput';
  agents: Array<AgentAvailabilityOutput>;
  busiestHourBusyCount: Scalars['Int']['output'];
  busiestHourUtc?: Maybe<Scalars['Int']['output']>;
};

export type ScopeOfAppointmentAdminInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ScopeOfAppointmentOutput = {
  __typename?: 'ScopeOfAppointmentOutput';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isConfirmed: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export enum ScopeOfAppointmentStatusDto {
  Opened = 'OPENED',
  Sent = 'SENT',
  Signed = 'SIGNED'
}

export type ScopeOfAppointmentUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type SendInBlueContactWithHistory = {
  __typename?: 'SendInBlueContactWithHistory';
  history: Array<Maybe<SendInBlueHistoryItem>>;
};

export type SendInBlueHistoryItem = {
  __typename?: 'SendInBlueHistoryItem';
  date: Scalars['Instant']['output'];
  fromEmail: Scalars['String']['output'];
  status: SendInBlueHistoryStatus;
  subject: Scalars['String']['output'];
  toEmail: Scalars['String']['output'];
};

export enum SendInBlueHistoryStatus {
  Blocked = 'BLOCKED',
  Clicks = 'CLICKS',
  Delivered = 'DELIVERED',
  Invalid = 'INVALID',
  Opened = 'OPENED',
  Unsubscribed = 'UNSUBSCRIBED'
}

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export enum Status {
  ApplicationSubmitted = 'APPLICATION_SUBMITTED',
  Attempted = 'ATTEMPTED',
  Contacted = 'CONTACTED',
  Disenrolled = 'DISENROLLED',
  Disqualified = 'DISQUALIFIED',
  Draft = 'DRAFT',
  Duplicated = 'DUPLICATED',
  FollowUp = 'FOLLOW_UP',
  NotYetEngaged = 'NOT_YET_ENGAGED',
  OutOfService = 'OUT_OF_SERVICE',
  SalesQualified = 'SALES_QUALIFIED',
  Test = 'TEST'
}

export enum StatusDto {
  ApplicationSubmitted = 'APPLICATION_SUBMITTED',
  Attempted = 'ATTEMPTED',
  Contacted = 'CONTACTED',
  Disenrolled = 'DISENROLLED',
  Disqualified = 'DISQUALIFIED',
  Draft = 'DRAFT',
  Duplicated = 'DUPLICATED',
  FollowUp = 'FOLLOW_UP',
  NotYetEngaged = 'NOT_YET_ENGAGED',
  OutOfService = 'OUT_OF_SERVICE',
  SalesQualified = 'SALES_QUALIFIED',
  Test = 'TEST'
}

export enum StatusOutput {
  Draft = 'DRAFT',
  Enrolled = 'ENROLLED',
  New = 'NEW',
  Rejected = 'REJECTED',
  Sent = 'SENT'
}

export type Subscription = {
  __typename?: 'Subscription';
  agentCallAgenda: AgentCallAgendaOutput;
  agentCallAgendaWholeState: CurrentAgentCallAgendaStateOutput;
  appointments: Array<AppointmentOutput>;
  calendarEventUpdates: CalendarEventUpdateOutput;
  clientCard: ClientViewOutput;
  dashboardView: DashboardSectionOutput;
  greetings: Scalars['String']['output'];
  newLeadsStatistics: NewLeadsStatisticsOutput;
  ping: Scalars['Long']['output'];
  requiredActions: Array<RequiredActionOutput>;
  slas: PageableSlaOutput;
  testSubscriptionError: Scalars['Long']['output'];
  urgentCallRequests: Array<UrgentRequestCallOutput>;
};


export type SubscriptionAppointmentsArgs = {
  agentId: Scalars['UUID']['input'];
};


export type SubscriptionCalendarEventUpdatesArgs = {
  agentEmail?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionClientCardArgs = {
  data: ClientDetailsSubscriptionInput;
};


export type SubscriptionDashboardViewArgs = {
  agentId?: InputMaybe<Scalars['UUID']['input']>;
};


export type SubscriptionSlasArgs = {
  filter: SlaFilterInput;
  pageInput: PageInput;
};

export type TagAssignedToClientInput = {
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  expiresAt?: InputMaybe<Scalars['Instant']['input']>;
  id: Scalars['UUID']['input'];
};

export type TagInput = {
  aiDescription?: InputMaybe<Scalars['String']['input']>;
  aiEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
};

export type TagOutput = {
  __typename?: 'TagOutput';
  aiDescription?: Maybe<Scalars['String']['output']>;
  aiEnabled?: Maybe<Scalars['Boolean']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

export type TagViewOutput = {
  __typename?: 'TagViewOutput';
  aiEnabled?: Maybe<Scalars['Boolean']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

export enum TrackingIdTypeDto {
  Google = 'GOOGLE',
  Opix = 'OPIX'
}

export type UpdateCalendarEventInput = {
  attendeeEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  colorId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDateTime?: InputMaybe<Scalars['Instant']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  reminderMinutes?: InputMaybe<Scalars['Int']['input']>;
  sendNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  startDateTime?: InputMaybe<Scalars['Instant']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export enum UrgentCallTypeDto {
  AsSoonAsPossible = 'AS_SOON_AS_POSSIBLE',
  ThisAfternoon = 'THIS_AFTERNOON',
  ThisMorning = 'THIS_MORNING'
}

export type UrgentRequestCallOutput = {
  __typename?: 'UrgentRequestCallOutput';
  clientId: Scalars['UUID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  urgentCallType?: Maybe<UrgentCallTypeDto>;
};

export type UserProfileFilterInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type UserProfileInput = {
  additionalInformation?: InputMaybe<Scalars['String']['input']>;
  adviserEmail?: InputMaybe<Scalars['String']['input']>;
  adviserName?: InputMaybe<Scalars['String']['input']>;
  agentId?: InputMaybe<Scalars['UUID']['input']>;
  aptNumber?: InputMaybe<Scalars['String']['input']>;
  attributes?: InputMaybe<Array<ProfileAttributeInput>>;
  birthDate?: InputMaybe<Scalars['LocalDate']['input']>;
  bookingFor?: InputMaybe<Scalars['String']['input']>;
  cId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  countyName?: InputMaybe<Scalars['String']['input']>;
  eligibleName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enrolled?: InputMaybe<Scalars['String']['input']>;
  fbclid?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  form?: InputMaybe<FormName>;
  gbraid?: InputMaybe<Scalars['String']['input']>;
  gclid?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hasNoPreferredDoctors?: InputMaybe<Scalars['Boolean']['input']>;
  hasNoPreferredPharmacies?: InputMaybe<Scalars['Boolean']['input']>;
  hasNoPrescriptionsDrugs?: InputMaybe<Scalars['Boolean']['input']>;
  insuranceType?: InputMaybe<Scalars['String']['input']>;
  isEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  medicareNumber?: InputMaybe<Scalars['String']['input']>;
  medicarePartAStartedAt?: InputMaybe<Scalars['String']['input']>;
  medicarePartBStartedAt?: InputMaybe<Scalars['String']['input']>;
  medigapQuoteId?: InputMaybe<Scalars['UUID']['input']>;
  msclkid?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<ProfileOption>>;
  pdpQuoteId?: InputMaybe<Scalars['UUID']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber2?: InputMaybe<Scalars['String']['input']>;
  planTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  profileId?: InputMaybe<Scalars['UUID']['input']>;
  quoteId?: InputMaybe<Scalars['UUID']['input']>;
  retireIn3Months?: InputMaybe<Scalars['String']['input']>;
  soaAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<ProfileSource>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<RequestStatusDto>;
  streetName?: InputMaybe<Scalars['String']['input']>;
  tobacco?: InputMaybe<Scalars['Boolean']['input']>;
  uId?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
  utmBrand?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
  wbraid?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UserProfileInputForAdviserInput = {
  birthDate?: InputMaybe<Scalars['LocalDate']['input']>;
  countyName?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UserProfileOutput = {
  __typename?: 'UserProfileOutput';
  additionalInformation?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['Int']['output']>;
  aptNumber?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['LocalDate']['output']>;
  bookingFor?: Maybe<Scalars['String']['output']>;
  cId?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['UUID']['output']>;
  countyName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  eligibleName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  hasNoPreferredDoctors?: Maybe<Scalars['Boolean']['output']>;
  hasNoPreferredPharmacies?: Maybe<Scalars['Boolean']['output']>;
  hasNoPrescriptionsDrugs?: Maybe<Scalars['Boolean']['output']>;
  isEmailVerified?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  medicareNumber?: Maybe<Scalars['String']['output']>;
  medicarePartAStartedAt?: Maybe<Scalars['String']['output']>;
  medicarePartBStartedAt?: Maybe<Scalars['String']['output']>;
  medigapQuoteId?: Maybe<Scalars['UUID']['output']>;
  pdpQuoteId?: Maybe<Scalars['UUID']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumber2?: Maybe<Scalars['String']['output']>;
  planTypes?: Maybe<Array<Scalars['String']['output']>>;
  profileId: Scalars['UUID']['output'];
  quoteId?: Maybe<Scalars['UUID']['output']>;
  retireIn3Months?: Maybe<Scalars['String']['output']>;
  soaAgreement?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  streetName?: Maybe<Scalars['String']['output']>;
  tobacco?: Maybe<Scalars['Boolean']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['UUID']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type UserProfileSaveOutput = {
  __typename?: 'UserProfileSaveOutput';
  clientId?: Maybe<Scalars['UUID']['output']>;
  enrollmentId?: Maybe<Scalars['UUID']['output']>;
  profileId: Scalars['UUID']['output'];
  userId?: Maybe<Scalars['UUID']['output']>;
  userToken?: Maybe<UserToken>;
};

export enum UserRole {
  /** @deprecated this is legacy role for agent. todo - use ROLE_AGENT instead */
  RoleAdmin = 'ROLE_ADMIN',
  RoleAdviser = 'ROLE_ADVISER',
  RoleAgentManager = 'ROLE_AGENT_MANAGER',
  RoleCsr = 'ROLE_CSR',
  RoleNone = 'ROLE_NONE',
  RoleSuperAdmin = 'ROLE_SUPER_ADMIN',
  RoleTechStaff = 'ROLE_TECH_STAFF',
  RoleUnauthorized = 'ROLE_UNAUTHORIZED',
  RoleUser = 'ROLE_USER'
}

export type UserToken = {
  __typename?: 'UserToken';
  accessToken: Scalars['String']['output'];
  idToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export type WrapUpClientOutput = {
  __typename?: 'WrapUpClientOutput';
  clientId: Scalars['UUID']['output'];
  detail?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type WrapUpSectionOutput = {
  __typename?: 'WrapUpSectionOutput';
  expiredCloseDate: Array<WrapUpClientOutput>;
  expiredNextContact: Array<WrapUpClientOutput>;
  undispositioned: Array<WrapUpClientOutput>;
};
